import _typeof from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/typeof";
import _objectSpread from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
function _regeneratorRuntime() {
  "use strict";

  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  _regeneratorRuntime = function _regeneratorRuntime() {
    return e;
  };
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@iterator",
    c = i.asyncIterator || "@asyncIterator",
    u = i.toStringTag || "@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function define(t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function value(t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(_typeof(e) + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function stop() {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function complete(t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function finish(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    "catch": function _catch(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
} /*@通用-数据层*/
import { get_cta_wan as _get_cta_wan, create_cta_wan as _create_cta_wan, update_cta_wan as _update_cta_wan, delete_cta_wan as _delete_cta_wan, check_lan_only as _check_lan_only, get_isp_dict as _get_isp_dict, get_available_ports_for_wan as _get_available_ports_for_wan, get_cta_lan as _get_cta_lan, create_cta_lan as _create_cta_lan, update_cta_lan as _update_cta_lan, delete_cta_lan as _delete_cta_lan, get_cta_wifi as _get_cta_wifi, get_cta_static_ip as _get_cta_static_ip, create_cta_static_ip as _create_cta_static_ip, update_cta_static_ip as _update_cta_static_ip, delete_cta_static_ip as _delete_cta_static_ip, create_cta_wifi as _create_cta_wifi, update_cta_wifi as _update_cta_wifi, delete_cta_wifi as _delete_cta_wifi, get_cpe_template_agency as _get_cpe_template_agency, get_physical_ports_info as _get_physical_ports_info, update_cpe_template_agency as _update_cpe_template_agency, get_cta_static_route as _get_cta_static_route, create_cta_static_route as _create_cta_static_route, update_cta_static_route as _update_cta_static_route, delete_cta_static_route as _delete_cta_static_route, get_cta_static_parse as _get_cta_static_parse, create_cta_static_parse as _create_cta_static_parse, update_cta_static_parse as _update_cta_static_parse, delete_cta_static_parse as _delete_cta_static_parse, get_ipset_by_cta_lan as _get_ipset_by_cta_lan, update_agency as _update_agency, get_start_end_ip as _get_start_end_ip, get_tunnel_snat as _get_tunnel_snat, create_tunnel_snat as _create_tunnel_snat, delete_tunnel_snat as _delete_tunnel_snat, update_tunnel_snat as _update_tunnel_snat, get_tunnel_dnat as _get_tunnel_dnat, create_tunnel_dnat as _create_tunnel_dnat, update_tunnel_dnat as _update_tunnel_dnat, delete_tunnel_dnat as _delete_tunnel_dnat, get_available_ports_for_vlan as _get_available_ports_for_vlan, create_cta_vlan as _create_cta_vlan, update_cta_vlan as _update_cta_vlan, get_cta_vlan as _get_cta_vlan, delete_cta_vlan as _delete_cta_vlan, get_cta_dnat as _get_cta_dnat, update_cta_dnat as _update_cta_dnat, create_cta_dnat as _create_cta_dnat, delete_cta_dnat as _delete_cta_dnat, get_crash as _get_crash, get_multi_dns as _get_multi_dns, create_multi_dns as _create_multi_dns, update_multi_dns as _update_multi_dns, delete_multi_dns as _delete_multi_dns, get_step_userinfo as _get_step_userinfo, get_centre_agency_detail as _get_centre_agency_detail, create_vyos_lan as _create_vyos_lan, update_vyos_lan as _update_vyos_lan, delete_vyos_lan as _delete_vyos_lan, get_vyos_lan as _get_vyos_lan, bind_vyos_dhcp as _bind_vyos_dhcp, create_vyos_vlan as _create_vyos_vlan, update_vyos_vlan as _update_vyos_vlan, delete_vyos_vlan as _delete_vyos_vlan, bind_wan_firewall as _bind_wan_firewall, bind_redirect_ip as _bind_redirect_ip, bind_wan_snat as _bind_wan_snat, bind_wan_dns_interception as _bind_wan_dns_interception, get_policy_number_range as _get_policy_number_range, bind_tunnel_flow as _bind_tunnel_flow, create_vyos_wan as _create_vyos_wan, update_vyos_wan as _update_vyos_wan, delete_vyos_wan as _delete_vyos_wan, get_vyos_wan as _get_vyos_wan, get_available_ports as _get_available_ports, get_interface_alias as _get_interface_alias, get_vyos_static_route as _get_vyos_static_route, create_vyos_static_route as _create_vyos_static_route, update_vyos_static_route as _update_vyos_static_route, delete_vyos_static_route as _delete_vyos_static_route, get_vyos_vlan as _get_vyos_vlan, get_bgp as _get_bgp, create_bgp as _create_bgp, query_bgp_neighbor_list, create_bgp_neighbor as _create_bgp_neighbor, update_bgp_neighbor as _update_bgp_neighbor, delete_bgp_neighbor as _delete_bgp_neighbor, update_ospf as _update_ospf, query_ospf_area_list as _query_ospf_area_list, create_ospf_area as _create_ospf_area, update_ospf_area as _update_ospf_area, delete_ospf_area as _delete_ospf_area, create_ospf_area_network as _create_ospf_area_network, query_ospf_area_network as _query_ospf_area_network, delete_ospf_area_network as _delete_ospf_area_network, update_ospf_area_network as _update_ospf_area_network, query_pbr_list as _query_pbr_list, create_pbr as _create_pbr, update_pbr as _update_pbr, delete_pbr as _delete_pbr, get_network_interface as _get_network_interface, update_pbr_detail as _update_pbr_detail, query_acl_config_list as _query_acl_config_list, create_acl_config as _create_acl_config, update_acl_config as _update_acl_config, delete_acl_config as _delete_acl_config, active_acl_config as _active_acl_config, push_command as _push_command, bind_vlan_firewall as _bind_vlan_firewall, create_ospf_redistribute_type as _create_ospf_redistribute_type, delete_ospf_redistribute_type as _delete_ospf_redistribute_type, update_ospf_redistribute_type as _update_ospf_redistribute_type, query_ospf_redistribute_type as _query_ospf_redistribute_type, query_device_ip_group as _query_device_ip_group, create_device_ip_group as _create_device_ip_group, update_device_ip_group as _update_device_ip_group, delete_device_ip_group as _delete_device_ip_group, unbind_ip_group as _unbind_ip_group } from "../../services/CI/CI2802S";
import { push_config as _push_config, get_uci_command as _get_uci_command, get_port_detect as _get_port_detect, get_device_list as _get_device_list, get_domain_group as _get_domain_group, get_all_alarms_count as _get_all_alarms_count, get_app_account_stat as _get_app_account_stat, get_wan_info as _get_wan_info, update_device as _update_device, get_link_list as _get_link_list, get_link as _get_link, get_l3_tunnel as _get_l3_tunnel, get_device_model as _get_device_model, all_company_update, cstep_device_changed, get_port_series as _get_port_series, delete_uci_command as _delete_uci_command, get_ip_groups as _get_ip_groups, get_alert_history_count as _get_alert_history_count, query_alert_history as _query_alert_history } from "../../services/Company/companyS";
import { get_interface as _get_interface } from '../../services/rate/rateS';
import { BossMessage } from "../../components/Common/BossMessages";
import { get_link_list_by_sn as _get_link_list_by_sn } from "../../services/CI/CI0602S";
var initState = {
  //
  cpeTemplate: [],
  physical: [],
  //WAN
  dataWan: [],
  ispList: [],
  portsList: [],
  checkLan: '',
  checkLans: '',
  //LAN
  dataLan: [],
  ctaStatic: [],
  wifiList: [],
  ipPool: [],
  //WIFI
  //Route
  routeList: [],
  dataWanLan: [],
  //DNS
  dnsList: [],
  //私网IP
  ipset: [],
  rows: 1,
  tunnelSnatData: [],
  tunnelDnatData: [],
  portDetect: [],
  portDetailStatusList: [],
  upDownInfo: [],
  portListForVlan: [],
  ctaDnatList: [],
  uciCommandList: [],
  uciCommandListTotal: 0,
  multiDns: [],
  vlanData: [],
  deviceData: [],
  domainGroupList: [],
  allalarmscount: 0,
  alarmList: [],
  alarmListTotal: 0,
  crashData: {
    panic: [],
    reboot: []
  },
  appAccount: {
    app_count: 0,
    app_limit: 0
  },
  dataSource: [],
  linkTotal: 0,
  link_info: {},
  l3TunnelData: [],
  stepUserInfo: [],
  agencyDetailData: {},
  wifiBandList: [],
  portSeriesData: {},
  interface_type: '',
  bgpNeighborList1: [],
  bgpNeighborList2: [],
  bgpNeighborList3: [],
  bgpNeighborTotal1: 0,
  bgpNeighborTotal2: 0,
  bgpNeighborTotal3: 0,
  ospfRouterId: '',
  ospfAreaList: [],
  ospfNetworkList: [],
  initPbrPayload: {},
  interfaceList: [],
  ipGroupDataForCompany: [],
  ipGroupSourceData: [],
  aclList: [],
  aclTotal: 0,
  initAclPayload: {},
  linkList: [],
  ospfRedistributeList: [],
  deviceIpList: [],
  initPayloadForDeviceIp: {},
  ipGroupDeviceDataForCompany: []
};
export default {
  namespace: "ci2802Info",
  state: initState,
  effects: {
    //
    get_physical_ports_info: function get_physical_ports_info(_ref, _ref2) {
      var payload = _ref.payload;
      var call = _ref2.call,
        put = _ref2.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var backData, i;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              backData = {}; // if(payload.sn && payload.sn.indexOf('L7')>-1){
              //     backData=yield call(get_vyos_physical_ports_info,{cta_id:payload.cta_id});
              //
              // } else {
              //     backData=yield call(get_physical_ports_info,{cta_id:payload.cta_id,is_new:payload.is_new?1:0});
              //
              // }
              _context.next = 3;
              return call(_get_physical_ports_info, {
                cta_id: payload.cta_id,
                is_new: payload.is_new ? 1 : 0
              });
            case 3:
              backData = _context.sent;
              backData.result.filter(function (item) {
                return item.port_type === '4g';
              });
              for (i = 0; i < backData.result.length; i++) {
                if (backData.result[i].port_type === '4g') {
                  // const backData2=yield call(get_4g_strength_latest,{
                  //     sn:payload.sn,
                  //     iface:backData.result[i].detail.interface
                  // });
                  backData.result[i].g4Strength = 0;
                }
              }
              _context.next = 8;
              return put({
                type: "update",
                payload: {
                  physical: backData.result,
                  rows: backData.rows
                }
              });
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee);
      })();
    },
    get_cpe_template_agency: function get_cpe_template_agency(_ref3, _ref4) {
      var payload = _ref3.payload;
      var call = _ref4.call,
        put = _ref4.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return call(_get_cpe_template_agency, payload);
            case 2:
              backData = _context2.sent;
              _context2.next = 5;
              return put({
                type: "update",
                payload: {
                  cpeTemplate: backData.result && Array.isArray(backData.result) ? backData.result : []
                }
              });
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      })();
    },
    update_cpe_template_agency: function update_cpe_template_agency(_ref5, _ref6) {
      var payload = _ref5.payload;
      var call = _ref6.call,
        put = _ref6.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return call(_update_cpe_template_agency, payload);
            case 2:
              backData = _context3.sent;
              if (backData.success) {
                BossMessage(true, "Update successful");
              } else {
                BossMessage(false, "Update failed" + backData.result);
              }
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      })();
    },
    //WAN
    get_cta_wan: function get_cta_wan(_ref7, _ref8) {
      var payload = _ref7.payload;
      var call = _ref8.call,
        put = _ref8.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return call(_get_cta_wan, payload);
            case 2:
              backData = _context4.sent;
              _context4.next = 5;
              return put({
                type: "update",
                payload: {
                  dataWan: backData && backData.result && Array.isArray(backData.result) ? backData.result : []
                }
              });
            case 5:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      })();
    },
    get_isp_dict: function get_isp_dict(_ref9, _ref10) {
      var payload = _ref9.payload;
      var call = _ref10.call,
        put = _ref10.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return call(_get_isp_dict, payload);
            case 2:
              backData = _context5.sent;
              _context5.next = 5;
              return put({
                type: "update",
                payload: {
                  ispList: backData.result
                }
              });
            case 5:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      })();
    },
    get_available_ports_for_wan: function get_available_ports_for_wan(_ref11, _ref12) {
      var payload = _ref11.payload;
      var call = _ref12.call,
        put = _ref12.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return call(_get_available_ports_for_wan, payload);
            case 2:
              backData = _context6.sent;
              _context6.next = 5;
              return put({
                type: "update",
                payload: {
                  portsList: backData.result && Array.isArray(backData.result) ? backData.result : []
                }
              });
            case 5:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      })();
    },
    get_available_ports: function get_available_ports(_ref13, _ref14) {
      var payload = _ref13.payload;
      var call = _ref14.call,
        put = _ref14.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return call(_get_available_ports, payload);
            case 2:
              backData = _context7.sent;
              _context7.next = 5;
              return put({
                type: "update",
                payload: {
                  portsList: backData.data && backData.data.result && Array.isArray(backData.data.result) ? backData.data.result : []
                }
              });
            case 5:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      })();
    },
    delete_cta_wan: function delete_cta_wan(_ref15, _ref16) {
      var payload = _ref15.payload;
      var call = _ref16.call,
        put = _ref16.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return call(_delete_cta_wan, payload.update);
            case 2:
              backData = _context8.sent;
              if (!backData.success) {
                _context8.next = 11;
                break;
              }
              BossMessage(true, "Successfully deleted");
              _context8.next = 7;
              return call(all_company_update, {
                company_id: payload.initcompany.company_id
              });
            case 7:
              _context8.next = 9;
              return put({
                type: "get_cta_wan",
                payload: {
                  cta_id: payload.update.cta_id
                }
              });
            case 9:
              _context8.next = 12;
              break;
            case 11:
              BossMessage(false, "Delete failed" + backData.result);
            case 12:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      })();
    },
    create_cta_wan: function create_cta_wan(_ref17, _ref18) {
      var payload = _ref17.payload;
      var call = _ref18.call,
        put = _ref18.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return call(_create_cta_wan, payload.update);
            case 2:
              backData = _context9.sent;
              if (!backData.success) {
                _context9.next = 13;
                break;
              }
              BossMessage(true, "Successfully added");
              _context9.next = 7;
              return call(all_company_update, {
                company_id: payload.initcompany.company_id
              });
            case 7:
              _context9.next = 9;
              return put({
                type: "get_cta_wan",
                payload: {
                  cta_id: payload.update.cta_id
                }
              });
            case 9:
              _context9.next = 11;
              return put({
                type: "get_physical_ports_info",
                payload: {
                  cta_id: payload.update.cta_id
                }
              });
            case 11:
              _context9.next = 14;
              break;
            case 13:
              BossMessage(false, "Add failed:" + backData.result);
            case 14:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      })();
    },
    check_lan_only: function check_lan_only(_ref19, _ref20) {
      var payload = _ref19.payload,
        callback = _ref19.callback;
      var call = _ref20.call,
        put = _ref20.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
        var backData, checkLan;
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 2;
              return call(_check_lan_only, payload);
            case 2:
              backData = _context10.sent;
              if (!backData.result) {
                _context10.next = 20;
                break;
              }
              checkLan = "";
              _context10.t0 = window.appLocale.locale;
              _context10.next = _context10.t0 === "en-US" ? 8 : _context10.t0 === "zh-TW" ? 10 : 12;
              break;
            case 8:
              checkLan = "This physical port has been used by " + backData.lan + ". Forced use of this port will result in the " + backData.lan + " segment being unavailable.";
              return _context10.abrupt("break", 14);
            case 10:
              checkLan = "該物理埠已經被" + backData.lan + "使用，強制使用該埠將會導致" + backData.lan + "網段無法使用.";
              return _context10.abrupt("break", 14);
            case 12:
              checkLan = "该物理端口已经被" + backData.lan + "使用，强制使用该端口将会导致" + backData.lan + "网段无法使用.";
              return _context10.abrupt("break", 14);
            case 14:
              if (callback && typeof callback === 'function') {
                callback('error', checkLan);
              }
              _context10.next = 17;
              return put({
                type: "update",
                payload: {
                  checkLan: checkLan,
                  //（"+payload.physical_port+"）
                  checkLans: "error"
                }
              });
            case 17:
              BossMessage(false, checkLan); //（"+payload.physical_port+"）
              _context10.next = 23;
              break;
            case 20:
              if (callback && typeof callback === 'function') {
                callback('');
              }
              _context10.next = 23;
              return put({
                type: "update",
                payload: {
                  checkLan: "",
                  checkLans: ""
                }
              });
            case 23:
            case "end":
              return _context10.stop();
          }
        }, _callee10);
      })();
    },
    reset_lan_only: function reset_lan_only(_ref21, _ref22) {
      var payload = _ref21.payload;
      var call = _ref22.call,
        put = _ref22.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              _context11.next = 2;
              return put({
                type: "update",
                payload: {
                  checkLan: "",
                  checkLans: ""
                }
              });
            case 2:
            case "end":
              return _context11.stop();
          }
        }, _callee11);
      })();
    },
    update_cta_wan: function update_cta_wan(_ref23, _ref24) {
      var payload = _ref23.payload;
      var call = _ref24.call,
        put = _ref24.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              _context12.next = 2;
              return call(_update_cta_wan, _objectSpread({}, payload.update, {
                gateway: payload.update.gateway ? payload.update.gateway : ""
              }));
            case 2:
              backData = _context12.sent;
              if (!backData.success) {
                _context12.next = 13;
                break;
              }
              BossMessage(true, "Update successful");
              _context12.next = 7;
              return call(all_company_update, {
                company_id: payload.initcompany.company_id
              });
            case 7:
              _context12.next = 9;
              return put({
                type: "get_cta_wan",
                payload: {
                  cta_id: payload.update.cta_id
                }
              });
            case 9:
              _context12.next = 11;
              return put({
                type: "get_physical_ports_info",
                payload: {
                  cta_id: payload.update.cta_id
                }
              });
            case 11:
              _context12.next = 14;
              break;
            case 13:
              BossMessage(false, "Update failed" + backData.result);
            case 14:
            case "end":
              return _context12.stop();
          }
        }, _callee12);
      })();
    },
    //LAN
    get_cta_lan: function get_cta_lan(_ref25, _ref26) {
      var payload = _ref25.payload;
      var call = _ref26.call,
        put = _ref26.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              _context13.next = 2;
              return call(_get_cta_lan, payload);
            case 2:
              backData = _context13.sent;
              _context13.next = 5;
              return put({
                type: "update",
                payload: {
                  dataLan: backData && backData.result && Array.isArray(backData.result) ? backData.result : []
                }
              });
            case 5:
            case "end":
              return _context13.stop();
          }
        }, _callee13);
      })();
    },
    get_cta_vlan: function get_cta_vlan(_ref27, _ref28) {
      var payload = _ref27.payload;
      var call = _ref28.call,
        put = _ref28.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee14() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              _context14.next = 2;
              return call(_get_cta_vlan, payload);
            case 2:
              backData = _context14.sent;
              _context14.next = 5;
              return put({
                type: "update",
                payload: {
                  vlanData: backData.result
                }
              });
            case 5:
            case "end":
              return _context14.stop();
          }
        }, _callee14);
      })();
    },
    get_cta_wifi: function get_cta_wifi(_ref29, _ref30) {
      var payload = _ref29.payload;
      var call = _ref30.call,
        put = _ref30.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee15() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              _context15.next = 2;
              return call(_get_cta_wifi, payload);
            case 2:
              backData = _context15.sent;
              _context15.next = 5;
              return put({
                type: "update",
                payload: {
                  wifiList: backData.result
                }
              });
            case 5:
            case "end":
              return _context15.stop();
          }
        }, _callee15);
      })();
    },
    delete_cta_lan: function delete_cta_lan(_ref31, _ref32) {
      var payload = _ref31.payload;
      var call = _ref32.call,
        put = _ref32.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee16() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee16$(_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              _context16.next = 2;
              return call(_delete_cta_lan, payload.update);
            case 2:
              backData = _context16.sent;
              if (!backData.success) {
                _context16.next = 11;
                break;
              }
              BossMessage(true, "Successfully deleted");
              _context16.next = 7;
              return call(all_company_update, {
                company_id: payload.initcompany.company_id
              });
            case 7:
              _context16.next = 9;
              return put({
                type: "get_cta_lan",
                payload: {
                  cta_id: payload.update.cta_id
                }
              });
            case 9:
              _context16.next = 12;
              break;
            case 11:
              BossMessage(false, "Delete failed" + backData.result);
            case 12:
            case "end":
              return _context16.stop();
          }
        }, _callee16);
      })();
    },
    create_cta_lan: function create_cta_lan(_ref33, _ref34) {
      var payload = _ref33.payload,
        callback = _ref33.callback;
      var call = _ref34.call,
        put = _ref34.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee17() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee17$(_context17) {
          while (1) switch (_context17.prev = _context17.next) {
            case 0:
              _context17.next = 2;
              return call(_create_cta_lan, payload.update);
            case 2:
              backData = _context17.sent;
              if (!backData.success) {
                _context17.next = 12;
                break;
              }
              BossMessage(true, "Successfully added");
              _context17.next = 7;
              return call(all_company_update, {
                company_id: payload.initcompany.company_id
              });
            case 7:
              _context17.next = 9;
              return put({
                type: "get_cta_lan",
                payload: {
                  cta_id: payload.update.cta_id
                }
              });
            case 9:
              if (callback && typeof callback === 'function') {
                callback();
              }
              _context17.next = 14;
              break;
            case 12:
              BossMessage(false, "Add failed:" + backData.result);
              if (callback && typeof callback === 'function') {
                callback({
                  noClose: true
                });
              }
            case 14:
            case "end":
              return _context17.stop();
          }
        }, _callee17);
      })();
    },
    update_cta_lan: function update_cta_lan(_ref35, _ref36) {
      var payload = _ref35.payload,
        callback = _ref35.callback;
      var call = _ref36.call,
        put = _ref36.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee18() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee18$(_context18) {
          while (1) switch (_context18.prev = _context18.next) {
            case 0:
              _context18.next = 2;
              return call(_update_cta_lan, payload.update);
            case 2:
              backData = _context18.sent;
              if (!backData.success) {
                _context18.next = 12;
                break;
              }
              BossMessage(true, "Update successful");
              _context18.next = 7;
              return call(all_company_update, {
                company_id: payload.initcompany.company_id
              });
            case 7:
              _context18.next = 9;
              return put({
                type: "get_cta_lan",
                payload: {
                  cta_id: payload.update.cta_id
                }
              });
            case 9:
              if (callback && typeof callback === 'function') {
                callback();
              }
              _context18.next = 14;
              break;
            case 12:
              BossMessage(false, "Update failed" + backData.result);
              if (callback && typeof callback === 'function') {
                callback({
                  noClose: true
                });
              }
            case 14:
            case "end":
              return _context18.stop();
          }
        }, _callee18);
      })();
    },
    get_cta_static_ip: function get_cta_static_ip(_ref37, _ref38) {
      var payload = _ref37.payload;
      var call = _ref38.call,
        put = _ref38.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee19() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee19$(_context19) {
          while (1) switch (_context19.prev = _context19.next) {
            case 0:
              _context19.next = 2;
              return call(_get_cta_static_ip, payload);
            case 2:
              backData = _context19.sent;
              _context19.next = 5;
              return put({
                type: "update",
                payload: {
                  ctaStatic: backData.result
                }
              });
            case 5:
            case "end":
              return _context19.stop();
          }
        }, _callee19);
      })();
    },
    create_cta_static_ip: function create_cta_static_ip(_ref39, _ref40) {
      var payload = _ref39.payload,
        callback = _ref39.callback;
      var call = _ref40.call,
        put = _ref40.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee20() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee20$(_context20) {
          while (1) switch (_context20.prev = _context20.next) {
            case 0:
              _context20.next = 2;
              return call(_create_cta_static_ip, payload.update);
            case 2:
              backData = _context20.sent;
              if (!backData.success) {
                _context20.next = 10;
                break;
              }
              BossMessage(true, "Successfully added");
              _context20.next = 7;
              return put({
                type: "get_cta_static_ip",
                payload: {
                  net_id: payload.update.cta_id,
                  cta_lan_id: payload.update.cta_lan_id
                }
              });
            case 7:
              if (callback && typeof callback === 'function') {
                callback({});
              }
              _context20.next = 12;
              break;
            case 10:
              BossMessage(false, "Add failed:" + backData.result);
              if (callback && typeof callback === 'function') {
                callback({
                  noClose: true
                });
              }
            case 12:
            case "end":
              return _context20.stop();
          }
        }, _callee20);
      })();
    },
    update_cta_static_ip: function update_cta_static_ip(_ref41, _ref42) {
      var payload = _ref41.payload,
        callback = _ref41.callback;
      var call = _ref42.call,
        put = _ref42.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee21() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee21$(_context21) {
          while (1) switch (_context21.prev = _context21.next) {
            case 0:
              _context21.next = 2;
              return call(_update_cta_static_ip, payload.update);
            case 2:
              backData = _context21.sent;
              if (!backData.success) {
                _context21.next = 10;
                break;
              }
              BossMessage(true, "Successfully modified");
              _context21.next = 7;
              return put({
                type: "get_cta_static_ip",
                payload: {
                  net_id: payload.update.cta_id,
                  cta_lan_id: payload.update.cta_lan_id
                }
              });
            case 7:
              if (callback && typeof callback === 'function') {
                callback({});
              }
              _context21.next = 12;
              break;
            case 10:
              BossMessage(false, "Modification failed" + backData.result);
              if (callback && typeof callback === 'function') {
                callback({
                  noClose: true
                });
              }
            case 12:
            case "end":
              return _context21.stop();
          }
        }, _callee21);
      })();
    },
    delete_cta_static_ip: function delete_cta_static_ip(_ref43, _ref44) {
      var payload = _ref43.payload;
      var call = _ref44.call,
        put = _ref44.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee22() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee22$(_context22) {
          while (1) switch (_context22.prev = _context22.next) {
            case 0:
              _context22.next = 2;
              return call(_delete_cta_static_ip, payload.data);
            case 2:
              backData = _context22.sent;
              if (!backData.success) {
                _context22.next = 9;
                break;
              }
              BossMessage(true, "Successfully deleted");
              _context22.next = 7;
              return put({
                type: "get_cta_static_ip",
                payload: {
                  net_id: payload.init.net_id,
                  cta_lan_id: payload.init.cta_lan_id
                }
              });
            case 7:
              _context22.next = 10;
              break;
            case 9:
              BossMessage(false, "Delete failed" + backData.result);
            case 10:
            case "end":
              return _context22.stop();
          }
        }, _callee22);
      })();
    },
    get_start_end_ip: function get_start_end_ip(_ref45, _ref46) {
      var payload = _ref45.payload;
      var call = _ref46.call,
        put = _ref46.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee23() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee23$(_context23) {
          while (1) switch (_context23.prev = _context23.next) {
            case 0:
              _context23.next = 2;
              return call(_get_start_end_ip, payload);
            case 2:
              backData = _context23.sent;
              _context23.next = 5;
              return put({
                type: "update",
                payload: {
                  ipPool: backData.result
                }
              });
            case 5:
            case "end":
              return _context23.stop();
          }
        }, _callee23);
      })();
    },
    //WIFI
    delete_cta_wifi: function delete_cta_wifi(_ref47, _ref48) {
      var payload = _ref47.payload;
      var call = _ref48.call,
        put = _ref48.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee24() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee24$(_context24) {
          while (1) switch (_context24.prev = _context24.next) {
            case 0:
              _context24.next = 2;
              return call(_delete_cta_wifi, payload.update);
            case 2:
              backData = _context24.sent;
              if (!backData.success) {
                _context24.next = 11;
                break;
              }
              BossMessage(true, "Successfully deleted");
              _context24.next = 7;
              return call(all_company_update, {
                company_id: payload.initcompany.company_id
              });
            case 7:
              _context24.next = 9;
              return put({
                type: "get_cta_wifi",
                payload: {
                  cta_id: payload.update.cta_id
                }
              });
            case 9:
              _context24.next = 12;
              break;
            case 11:
              BossMessage(false, "Delete failed" + backData.result);
            case 12:
            case "end":
              return _context24.stop();
          }
        }, _callee24);
      })();
    },
    create_cta_wifi: function create_cta_wifi(_ref49, _ref50) {
      var payload = _ref49.payload;
      var call = _ref50.call,
        put = _ref50.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee25() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee25$(_context25) {
          while (1) switch (_context25.prev = _context25.next) {
            case 0:
              _context25.next = 2;
              return call(_create_cta_wifi, payload.update);
            case 2:
              backData = _context25.sent;
              if (!backData.success) {
                _context25.next = 9;
                break;
              }
              BossMessage(true, "Successfully added");
              _context25.next = 7;
              return call(all_company_update, {
                company_id: payload.initcompany.company_id
              });
            case 7:
              _context25.next = 10;
              break;
            case 9:
              BossMessage(false, "Add failed:" + backData.result);
            case 10:
            case "end":
              return _context25.stop();
          }
        }, _callee25);
      })();
    },
    update_cta_wifi: function update_cta_wifi(_ref51, _ref52) {
      var payload = _ref51.payload;
      var call = _ref52.call,
        put = _ref52.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee26() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee26$(_context26) {
          while (1) switch (_context26.prev = _context26.next) {
            case 0:
              _context26.next = 2;
              return call(_update_cta_wifi, payload.update);
            case 2:
              backData = _context26.sent;
              if (!backData.success) {
                _context26.next = 9;
                break;
              }
              BossMessage(true, "Update successful");
              _context26.next = 7;
              return call(all_company_update, {
                company_id: payload.initcompany.company_id
              });
            case 7:
              _context26.next = 10;
              break;
            case 9:
              BossMessage(false, "Update failed" + backData.result);
            case 10:
            case "end":
              return _context26.stop();
          }
        }, _callee26);
      })();
    },
    //router
    delete_cta_static_route: function delete_cta_static_route(_ref53, _ref54) {
      var payload = _ref53.payload;
      var call = _ref54.call,
        put = _ref54.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee27() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee27$(_context27) {
          while (1) switch (_context27.prev = _context27.next) {
            case 0:
              _context27.next = 2;
              return call(_delete_cta_static_route, payload);
            case 2:
              backData = _context27.sent;
              if (!backData.success) {
                _context27.next = 9;
                break;
              }
              BossMessage(true, "Successfully deleted");
              _context27.next = 7;
              return put({
                type: "get_cta_static_route",
                payload: {
                  cta_id: payload.cta_id
                }
              });
            case 7:
              _context27.next = 10;
              break;
            case 9:
              BossMessage(false, "Delete failed" + backData.result);
            case 10:
            case "end":
              return _context27.stop();
          }
        }, _callee27);
      })();
    },
    create_cta_static_route: function create_cta_static_route(_ref55, _ref56) {
      var payload = _ref55.payload,
        callback = _ref55.callback;
      var call = _ref56.call,
        put = _ref56.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee28() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee28$(_context28) {
          while (1) switch (_context28.prev = _context28.next) {
            case 0:
              if (payload.update && String(payload.update.cta_lan_id) == 'undefined') {
                payload.update.cta_lan_id = 0;
              }
              _context28.next = 3;
              return call(_create_cta_static_route, payload.update);
            case 3:
              backData = _context28.sent;
              if (!backData.success) {
                _context28.next = 10;
                break;
              }
              BossMessage(true, "Successfully added");
              _context28.next = 8;
              return put({
                type: "get_cta_static_route",
                payload: {
                  cta_id: payload.update.cta_id
                }
              });
            case 8:
              _context28.next = 12;
              break;
            case 10:
              BossMessage(false, "Add failed:" + backData.result);
              if (callback && typeof callback === 'function') {
                callback({
                  noClose: true
                });
              }
            case 12:
            case "end":
              return _context28.stop();
          }
        }, _callee28);
      })();
    },
    update_cta_static_route: function update_cta_static_route(_ref57, _ref58) {
      var payload = _ref57.payload,
        callback = _ref57.callback;
      var call = _ref58.call,
        put = _ref58.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee29() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee29$(_context29) {
          while (1) switch (_context29.prev = _context29.next) {
            case 0:
              if (payload.update && String(payload.update.cta_lan_id) == 'undefined') {
                payload.update.cta_lan_id = 0;
              }
              _context29.next = 3;
              return call(_update_cta_static_route, payload.update);
            case 3:
              backData = _context29.sent;
              if (!backData.success) {
                _context29.next = 10;
                break;
              }
              BossMessage(true, "Update successful");
              _context29.next = 8;
              return put({
                type: "get_cta_static_route",
                payload: {
                  cta_id: payload.update.cta_id
                }
              });
            case 8:
              _context29.next = 12;
              break;
            case 10:
              BossMessage(false, "Update failed" + backData.result);
              if (callback && typeof callback === 'function') {
                callback({
                  noClose: true
                });
              }
            case 12:
            case "end":
              return _context29.stop();
          }
        }, _callee29);
      })();
    },
    get_cta_static_route: function get_cta_static_route(_ref59, _ref60) {
      var payload = _ref59.payload;
      var call = _ref60.call,
        put = _ref60.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee30() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee30$(_context30) {
          while (1) switch (_context30.prev = _context30.next) {
            case 0:
              _context30.next = 2;
              return call(_get_cta_static_route, payload);
            case 2:
              backData = _context30.sent;
              _context30.next = 5;
              return put({
                type: "update",
                payload: {
                  routeList: backData.result
                }
              });
            case 5:
            case "end":
              return _context30.stop();
          }
        }, _callee30);
      })();
    },
    get_wan_and_lan: function get_wan_and_lan(_ref61, _ref62) {
      var payload = _ref61.payload;
      var call = _ref62.call,
        put = _ref62.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee31() {
        var backData1, backData2, backData;
        return _regeneratorRuntime().wrap(function _callee31$(_context31) {
          while (1) switch (_context31.prev = _context31.next) {
            case 0:
              _context31.next = 2;
              return call(_get_cta_lan, payload);
            case 2:
              backData1 = _context31.sent;
              _context31.next = 5;
              return call(_get_cta_wan, payload);
            case 5:
              backData2 = _context31.sent;
              backData = backData1.result.concat(backData2.result);
              _context31.next = 9;
              return put({
                type: "update",
                payload: {
                  dataWanLan: backData
                }
              });
            case 9:
            case "end":
              return _context31.stop();
          }
        }, _callee31);
      })();
    },
    //DNS
    delete_cta_static_parse: function delete_cta_static_parse(_ref63, _ref64) {
      var payload = _ref63.payload;
      var call = _ref64.call,
        put = _ref64.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee32() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee32$(_context32) {
          while (1) switch (_context32.prev = _context32.next) {
            case 0:
              _context32.next = 2;
              return call(_delete_cta_static_parse, payload);
            case 2:
              backData = _context32.sent;
              if (!backData.success) {
                _context32.next = 9;
                break;
              }
              BossMessage(true, "Successfully deleted");
              _context32.next = 7;
              return put({
                type: "get_cta_static_parse",
                payload: {
                  cta_id: payload.cta_id
                }
              });
            case 7:
              _context32.next = 10;
              break;
            case 9:
              BossMessage(false, "Delete failed" + backData.result);
            case 10:
            case "end":
              return _context32.stop();
          }
        }, _callee32);
      })();
    },
    create_cta_static_parse: function create_cta_static_parse(_ref65, _ref66) {
      var payload = _ref65.payload;
      var call = _ref66.call,
        put = _ref66.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee33() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee33$(_context33) {
          while (1) switch (_context33.prev = _context33.next) {
            case 0:
              _context33.next = 2;
              return call(_create_cta_static_parse, payload.update);
            case 2:
              backData = _context33.sent;
              if (backData.success) {
                BossMessage(true, "Successfully added");
              } else {
                BossMessage(false, "Add failed:" + backData.result);
              }
            case 4:
            case "end":
              return _context33.stop();
          }
        }, _callee33);
      })();
    },
    update_cta_static_parse: function update_cta_static_parse(_ref67, _ref68) {
      var payload = _ref67.payload;
      var call = _ref68.call,
        put = _ref68.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee34() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee34$(_context34) {
          while (1) switch (_context34.prev = _context34.next) {
            case 0:
              _context34.next = 2;
              return call(_update_cta_static_parse, payload.update);
            case 2:
              backData = _context34.sent;
              if (backData.success) {
                BossMessage(true, "Update successful");
              } else {
                BossMessage(false, "Update failed" + backData.result);
              }
            case 4:
            case "end":
              return _context34.stop();
          }
        }, _callee34);
      })();
    },
    get_cta_static_parse: function get_cta_static_parse(_ref69, _ref70) {
      var payload = _ref69.payload;
      var call = _ref70.call,
        put = _ref70.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee35() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee35$(_context35) {
          while (1) switch (_context35.prev = _context35.next) {
            case 0:
              _context35.next = 2;
              return call(_get_cta_static_parse, payload);
            case 2:
              backData = _context35.sent;
              _context35.next = 5;
              return put({
                type: "update",
                payload: {
                  dnsList: backData.result
                }
              });
            case 5:
            case "end":
              return _context35.stop();
          }
        }, _callee35);
      })();
    },
    //IP
    get_ipset_by_cta_lan: function get_ipset_by_cta_lan(_ref71, _ref72) {
      var payload = _ref71.payload;
      var call = _ref72.call,
        put = _ref72.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee36() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee36$(_context36) {
          while (1) switch (_context36.prev = _context36.next) {
            case 0:
              _context36.next = 2;
              return call(_get_ipset_by_cta_lan, payload);
            case 2:
              backData = _context36.sent;
              _context36.next = 5;
              return put({
                type: "update",
                payload: {
                  ipset: backData.result
                }
              });
            case 5:
            case "end":
              return _context36.stop();
          }
        }, _callee36);
      })();
    },
    update_agency: function update_agency(_ref73, _ref74) {
      var payload = _ref73.payload;
      var call = _ref74.call,
        put = _ref74.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee37() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee37$(_context37) {
          while (1) switch (_context37.prev = _context37.next) {
            case 0:
              _context37.next = 2;
              return call(_update_agency, payload);
            case 2:
              backData = _context37.sent;
              if (backData.success) {
                BossMessage(true, "Successfully saved");
              } else {
                BossMessage(false, "Save failed" + backData.result);
              }
            case 4:
            case "end":
              return _context37.stop();
          }
        }, _callee37);
      })();
    },
    get_tunnel_snat: function get_tunnel_snat(_ref75, _ref76) {
      var payload = _ref75.payload;
      var call = _ref76.call,
        put = _ref76.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee38() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee38$(_context38) {
          while (1) switch (_context38.prev = _context38.next) {
            case 0:
              _context38.next = 2;
              return call(_get_tunnel_snat, payload);
            case 2:
              backData = _context38.sent;
              _context38.next = 5;
              return put({
                type: "update",
                payload: {
                  tunnelSnatData: backData.result
                }
              });
            case 5:
            case "end":
              return _context38.stop();
          }
        }, _callee38);
      })();
    },
    create_tunnel_snat: function create_tunnel_snat(_ref77, _ref78) {
      var payload = _ref77.payload;
      var call = _ref78.call,
        put = _ref78.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee39() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee39$(_context39) {
          while (1) switch (_context39.prev = _context39.next) {
            case 0:
              _context39.next = 2;
              return call(_create_tunnel_snat, payload.update);
            case 2:
              backData = _context39.sent;
              if (!backData.success) {
                _context39.next = 11;
                break;
              }
              BossMessage(true, "Successfully added");
              _context39.next = 7;
              return call(all_company_update, {
                company_id: payload.update.company_id
              });
            case 7:
              _context39.next = 9;
              return put({
                type: "get_tunnel_snat",
                payload: {
                  device_id: payload.update.device_id
                }
              });
            case 9:
              _context39.next = 12;
              break;
            case 11:
              BossMessage(false, "Add failed:" + backData.result);
            case 12:
            case "end":
              return _context39.stop();
          }
        }, _callee39);
      })();
    },
    delete_tunnel_snat: function delete_tunnel_snat(_ref79, _ref80) {
      var payload = _ref79.payload;
      var call = _ref80.call,
        put = _ref80.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee40() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee40$(_context40) {
          while (1) switch (_context40.prev = _context40.next) {
            case 0:
              _context40.next = 2;
              return call(_delete_tunnel_snat, payload.update);
            case 2:
              backData = _context40.sent;
              if (!backData.success) {
                _context40.next = 11;
                break;
              }
              BossMessage(true, "Successfully deleted");
              _context40.next = 7;
              return call(all_company_update, {
                company_id: payload.initcompany.company_id
              });
            case 7:
              _context40.next = 9;
              return put({
                type: "get_tunnel_snat",
                payload: {
                  device_id: payload.init.device_id
                }
              });
            case 9:
              _context40.next = 12;
              break;
            case 11:
              BossMessage(false, "Delete failed" + backData.result);
            case 12:
            case "end":
              return _context40.stop();
          }
        }, _callee40);
      })();
    },
    update_tunnel_snat: function update_tunnel_snat(_ref81, _ref82) {
      var payload = _ref81.payload;
      var call = _ref82.call,
        put = _ref82.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee41() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee41$(_context41) {
          while (1) switch (_context41.prev = _context41.next) {
            case 0:
              _context41.next = 2;
              return call(_update_tunnel_snat, payload.update);
            case 2:
              backData = _context41.sent;
              if (!backData.success) {
                _context41.next = 11;
                break;
              }
              BossMessage(true, "Update successful");
              _context41.next = 7;
              return call(all_company_update, {
                company_id: payload.initcompany.company_id
              });
            case 7:
              _context41.next = 9;
              return put({
                type: "get_tunnel_snat",
                payload: {
                  device_id: payload.init.device_id
                }
              });
            case 9:
              _context41.next = 12;
              break;
            case 11:
              BossMessage(false, "Update failed" + backData.result);
            case 12:
            case "end":
              return _context41.stop();
          }
        }, _callee41);
      })();
    },
    get_tunnel_dnat: function get_tunnel_dnat(_ref83, _ref84) {
      var payload = _ref83.payload;
      var call = _ref84.call,
        put = _ref84.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee42() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee42$(_context42) {
          while (1) switch (_context42.prev = _context42.next) {
            case 0:
              _context42.next = 2;
              return call(_get_tunnel_dnat, payload);
            case 2:
              backData = _context42.sent;
              _context42.next = 5;
              return put({
                type: "update",
                payload: {
                  tunnelDnatData: backData.result
                }
              });
            case 5:
            case "end":
              return _context42.stop();
          }
        }, _callee42);
      })();
    },
    create_tunnel_dnat: function create_tunnel_dnat(_ref85, _ref86) {
      var payload = _ref85.payload;
      var call = _ref86.call,
        put = _ref86.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee43() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee43$(_context43) {
          while (1) switch (_context43.prev = _context43.next) {
            case 0:
              _context43.next = 2;
              return call(_create_tunnel_dnat, payload.update);
            case 2:
              backData = _context43.sent;
              if (!backData.success) {
                _context43.next = 11;
                break;
              }
              BossMessage(true, "Successfully added");
              _context43.next = 7;
              return call(all_company_update, {
                company_id: payload.update.company_id
              });
            case 7:
              _context43.next = 9;
              return put({
                type: "get_tunnel_dnat",
                payload: {
                  device_id: payload.update.device_id
                }
              });
            case 9:
              _context43.next = 12;
              break;
            case 11:
              BossMessage(false, "Add failed:" + backData.result);
            case 12:
            case "end":
              return _context43.stop();
          }
        }, _callee43);
      })();
    },
    update_tunnel_dnat: function update_tunnel_dnat(_ref87, _ref88) {
      var payload = _ref87.payload;
      var call = _ref88.call,
        put = _ref88.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee44() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee44$(_context44) {
          while (1) switch (_context44.prev = _context44.next) {
            case 0:
              _context44.next = 2;
              return call(_update_tunnel_dnat, payload.update);
            case 2:
              backData = _context44.sent;
              if (!backData.success) {
                _context44.next = 11;
                break;
              }
              BossMessage(true, "Update successful");
              _context44.next = 7;
              return call(all_company_update, {
                company_id: payload.initcompany.company_id
              });
            case 7:
              _context44.next = 9;
              return put({
                type: "get_tunnel_dnat",
                payload: {
                  device_id: payload.init.device_id
                }
              });
            case 9:
              _context44.next = 12;
              break;
            case 11:
              BossMessage(false, "Update failed" + backData.result);
            case 12:
            case "end":
              return _context44.stop();
          }
        }, _callee44);
      })();
    },
    delete_tunnel_dnat: function delete_tunnel_dnat(_ref89, _ref90) {
      var payload = _ref89.payload;
      var call = _ref90.call,
        put = _ref90.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee45() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee45$(_context45) {
          while (1) switch (_context45.prev = _context45.next) {
            case 0:
              _context45.next = 2;
              return call(_delete_tunnel_dnat, payload.update);
            case 2:
              backData = _context45.sent;
              if (!backData.success) {
                _context45.next = 11;
                break;
              }
              BossMessage(true, "Successfully deleted");
              _context45.next = 7;
              return call(all_company_update, {
                company_id: payload.initcompany.company_id
              });
            case 7:
              _context45.next = 9;
              return put({
                type: "get_tunnel_dnat",
                payload: {
                  device_id: payload.init.device_id
                }
              });
            case 9:
              _context45.next = 12;
              break;
            case 11:
              BossMessage(false, "Delete failed" + backData.result);
            case 12:
            case "end":
              return _context45.stop();
          }
        }, _callee45);
      })();
    },
    push_config: function push_config(_ref91, _ref92) {
      var payload = _ref91.payload;
      var call = _ref92.call,
        put = _ref92.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee46() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee46$(_context46) {
          while (1) switch (_context46.prev = _context46.next) {
            case 0:
              _context46.next = 2;
              return call(_push_config, payload.update);
            case 2:
              backData = _context46.sent;
              if (!backData.success) {
                _context46.next = 10;
                break;
              }
              BossMessage(true, "Successfully pushed");
              if (!(payload.initcompany && payload.initcompany.sn)) {
                _context46.next = 8;
                break;
              }
              _context46.next = 8;
              return call(cstep_device_changed, {
                sn: payload.initcompany.sn,
                company_id: payload.initcompany.company_id
              });
            case 8:
              _context46.next = 11;
              break;
            case 10:
              BossMessage(false, "Push failed" + backData.result);
            case 11:
            case "end":
              return _context46.stop();
          }
        }, _callee46);
      })();
    },
    push_command: function push_command(_ref93, _ref94) {
      var payload = _ref93.payload;
      var call = _ref94.call,
        put = _ref94.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee47() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee47$(_context47) {
          while (1) switch (_context47.prev = _context47.next) {
            case 0:
              _context47.next = 2;
              return call(_push_command, payload.update);
            case 2:
              backData = _context47.sent;
              if (backData.success) {
                BossMessage(true, "Successfully pushed");
              } else {
                BossMessage(false, "Push failed" + backData.message);
              }
            case 4:
            case "end":
              return _context47.stop();
          }
        }, _callee47);
      })();
    },
    get_uci_command: function get_uci_command(_ref95, _ref96) {
      var payload = _ref95.payload;
      var call = _ref96.call,
        put = _ref96.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee48() {
        var backData, uciCommandList;
        return _regeneratorRuntime().wrap(function _callee48$(_context48) {
          while (1) switch (_context48.prev = _context48.next) {
            case 0:
              _context48.next = 2;
              return call(_get_uci_command, payload);
            case 2:
              backData = _context48.sent;
              uciCommandList = [];
              if (backData.result && backData.result.length > 0) {
                uciCommandList = backData.result.map(function (item, index) {
                  return _objectSpread({}, item, {
                    index: index
                  });
                });
              }
              _context48.next = 7;
              return put({
                type: "update",
                payload: {
                  uciCommandList: uciCommandList,
                  uciCommandListTotal: backData.total
                }
              });
            case 7:
            case "end":
              return _context48.stop();
          }
        }, _callee48);
      })();
    },
    get_port_detect: function get_port_detect(_ref97, _ref98) {
      var payload = _ref97.payload;
      var call = _ref98.call,
        put = _ref98.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee49() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee49$(_context49) {
          while (1) switch (_context49.prev = _context49.next) {
            case 0:
              _context49.next = 2;
              return call(_get_port_detect, payload);
            case 2:
              backData = _context49.sent;
              _context49.next = 5;
              return put({
                type: "update",
                payload: {
                  portDetect: backData.result
                }
              });
            case 5:
            case "end":
              return _context49.stop();
          }
        }, _callee49);
      })();
    },
    get_interface: function get_interface(_ref99, _ref100) {
      var payload = _ref99.payload;
      var call = _ref100.call,
        put = _ref100.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee50() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee50$(_context50) {
          while (1) switch (_context50.prev = _context50.next) {
            case 0:
              _context50.next = 2;
              return call(_get_interface, payload);
            case 2:
              backData = _context50.sent;
              if (!(backData.msg === "ok")) {
                _context50.next = 6;
                break;
              }
              _context50.next = 6;
              return put({
                type: "update",
                payload: {
                  upDownInfo: backData && backData.data && Array.isArray(backData.data) ? backData.data : []
                }
              });
            case 6:
            case "end":
              return _context50.stop();
          }
        }, _callee50);
      })();
    },
    get_available_ports_for_vlan: function get_available_ports_for_vlan(_ref101, _ref102) {
      var payload = _ref101.payload;
      var call = _ref102.call,
        put = _ref102.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee51() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee51$(_context51) {
          while (1) switch (_context51.prev = _context51.next) {
            case 0:
              _context51.next = 2;
              return call(_get_available_ports_for_vlan, payload);
            case 2:
              backData = _context51.sent;
              _context51.next = 5;
              return put({
                type: "update",
                payload: {
                  portListForVlan: backData.result
                }
              });
            case 5:
            case "end":
              return _context51.stop();
          }
        }, _callee51);
      })();
    },
    create_cta_vlan: function create_cta_vlan(_ref103, _ref104) {
      var payload = _ref103.payload,
        callback = _ref103.callback;
      var call = _ref104.call,
        put = _ref104.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee52() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee52$(_context52) {
          while (1) switch (_context52.prev = _context52.next) {
            case 0:
              _context52.next = 2;
              return call(_create_cta_vlan, payload.update);
            case 2:
              backData = _context52.sent;
              if (!backData.success) {
                _context52.next = 10;
                break;
              }
              BossMessage(true, "Successfully added");
              _context52.next = 7;
              return put({
                type: "get_cta_lan",
                payload: {
                  cta_id: payload.update.cta_id
                }
              });
            case 7:
              if (callback && typeof callback === 'function') {
                callback();
              }
              _context52.next = 12;
              break;
            case 10:
              BossMessage(false, "Add failed:" + backData.result);
              if (callback && typeof callback === 'function') {
                callback({
                  noClose: true
                });
              }
            case 12:
            case "end":
              return _context52.stop();
          }
        }, _callee52);
      })();
    },
    update_cta_vlan: function update_cta_vlan(_ref105, _ref106) {
      var payload = _ref105.payload,
        callback = _ref105.callback;
      var call = _ref106.call,
        put = _ref106.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee53() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee53$(_context53) {
          while (1) switch (_context53.prev = _context53.next) {
            case 0:
              _context53.next = 2;
              return call(_update_cta_vlan, payload.update);
            case 2:
              backData = _context53.sent;
              if (!backData.success) {
                _context53.next = 10;
                break;
              }
              BossMessage(true, "Update successful");
              _context53.next = 7;
              return put({
                type: "get_cta_lan",
                payload: {
                  cta_id: payload.update.cta_id
                }
              });
            case 7:
              if (callback && typeof callback === 'function') {
                callback();
              }
              _context53.next = 12;
              break;
            case 10:
              BossMessage(false, "Update failed" + backData.result);
              if (callback && typeof callback === 'function') {
                callback({
                  noClose: true
                });
              }
            case 12:
            case "end":
              return _context53.stop();
          }
        }, _callee53);
      })();
    },
    delete_cta_vlan: function delete_cta_vlan(_ref107, _ref108) {
      var payload = _ref107.payload;
      var call = _ref108.call,
        put = _ref108.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee54() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee54$(_context54) {
          while (1) switch (_context54.prev = _context54.next) {
            case 0:
              _context54.next = 2;
              return call(_delete_cta_vlan, payload);
            case 2:
              backData = _context54.sent;
              if (!backData.success) {
                _context54.next = 9;
                break;
              }
              BossMessage(true, "Successfully deleted");
              _context54.next = 7;
              return put({
                type: "get_cta_lan",
                payload: {
                  cta_id: payload.cta_id
                }
              });
            case 7:
              _context54.next = 10;
              break;
            case 9:
              BossMessage(false, "Delete failed" + backData.result);
            case 10:
            case "end":
              return _context54.stop();
          }
        }, _callee54);
      })();
    },
    get_cta_dnat: function get_cta_dnat(_ref109, _ref110) {
      var payload = _ref109.payload;
      var call = _ref110.call,
        put = _ref110.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee55() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee55$(_context55) {
          while (1) switch (_context55.prev = _context55.next) {
            case 0:
              _context55.next = 2;
              return call(_get_cta_dnat, payload);
            case 2:
              backData = _context55.sent;
              _context55.next = 5;
              return put({
                type: "update",
                payload: {
                  ctaDnatList: backData.result
                }
              });
            case 5:
            case "end":
              return _context55.stop();
          }
        }, _callee55);
      })();
    },
    create_cta_dnat: function create_cta_dnat(_ref111, _ref112) {
      var payload = _ref111.payload;
      var call = _ref112.call,
        put = _ref112.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee56() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee56$(_context56) {
          while (1) switch (_context56.prev = _context56.next) {
            case 0:
              _context56.next = 2;
              return call(_create_cta_dnat, payload.update);
            case 2:
              backData = _context56.sent;
              if (!backData.success) {
                _context56.next = 9;
                break;
              }
              BossMessage(true, "Successfully added");
              _context56.next = 7;
              return put({
                type: "get_cta_dnat",
                payload: {
                  cta_id: payload.update.cta_id
                }
              });
            case 7:
              _context56.next = 10;
              break;
            case 9:
              BossMessage(false, "Add failed:" + backData.result);
            case 10:
            case "end":
              return _context56.stop();
          }
        }, _callee56);
      })();
    },
    update_cta_dnat: function update_cta_dnat(_ref113, _ref114) {
      var payload = _ref113.payload;
      var call = _ref114.call,
        put = _ref114.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee57() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee57$(_context57) {
          while (1) switch (_context57.prev = _context57.next) {
            case 0:
              _context57.next = 2;
              return call(_update_cta_dnat, payload.update);
            case 2:
              backData = _context57.sent;
              if (!backData.success) {
                _context57.next = 9;
                break;
              }
              BossMessage(true, "Update successful");
              _context57.next = 7;
              return put({
                type: "get_cta_dnat",
                payload: {
                  cta_id: payload.update.cta_id
                }
              });
            case 7:
              _context57.next = 10;
              break;
            case 9:
              BossMessage(false, "Update failed" + backData.result);
            case 10:
            case "end":
              return _context57.stop();
          }
        }, _callee57);
      })();
    },
    delete_cta_dnat: function delete_cta_dnat(_ref115, _ref116) {
      var payload = _ref115.payload;
      var call = _ref116.call,
        put = _ref116.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee58() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee58$(_context58) {
          while (1) switch (_context58.prev = _context58.next) {
            case 0:
              _context58.next = 2;
              return call(_delete_cta_dnat, payload);
            case 2:
              backData = _context58.sent;
              if (!backData.success) {
                _context58.next = 9;
                break;
              }
              BossMessage(true, "Successfully deleted");
              _context58.next = 7;
              return put({
                type: "get_cta_dnat",
                payload: {
                  cta_id: payload.cta_id
                }
              });
            case 7:
              _context58.next = 10;
              break;
            case 9:
              BossMessage(false, "Delete failed" + backData.result);
            case 10:
            case "end":
              return _context58.stop();
          }
        }, _callee58);
      })();
    },
    //24小时内异常/重启次数
    get_crash: function get_crash(_ref117, _ref118) {
      var payload = _ref117.payload;
      var call = _ref118.call,
        put = _ref118.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee59() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee59$(_context59) {
          while (1) switch (_context59.prev = _context59.next) {
            case 0:
              _context59.next = 2;
              return call(_get_crash, payload);
            case 2:
              backData = _context59.sent;
              _context59.next = 5;
              return put({
                type: "update",
                payload: {
                  crashData: {
                    panic: backData.data && backData.data.panic && Array.isArray(backData.data.panic) ? backData.data.panic : [],
                    reboot: backData.data && backData.data.reboot && Array.isArray(backData.data.reboot) ? backData.data.reboot : []
                  }
                }
              });
            case 5:
            case "end":
              return _context59.stop();
          }
        }, _callee59);
      })();
    },
    get_multi_dns: function get_multi_dns(_ref119, _ref120) {
      var payload = _ref119.payload;
      var call = _ref120.call,
        put = _ref120.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee60() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee60$(_context60) {
          while (1) switch (_context60.prev = _context60.next) {
            case 0:
              _context60.next = 2;
              return call(_get_multi_dns, payload);
            case 2:
              backData = _context60.sent;
              _context60.next = 5;
              return put({
                type: "update",
                payload: {
                  multiDns: backData.result
                }
              });
            case 5:
            case "end":
              return _context60.stop();
          }
        }, _callee60);
      })();
    },
    create_multi_dns: function create_multi_dns(_ref121, _ref122) {
      var payload = _ref121.payload;
      var call = _ref122.call,
        put = _ref122.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee61() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee61$(_context61) {
          while (1) switch (_context61.prev = _context61.next) {
            case 0:
              _context61.next = 2;
              return call(_create_multi_dns, payload.update);
            case 2:
              backData = _context61.sent;
              if (!backData.success) {
                _context61.next = 9;
                break;
              }
              BossMessage(true, "Successfully added");
              _context61.next = 7;
              return put({
                type: "get_multi_dns",
                payload: {
                  device_id: payload.update.device_id
                }
              });
            case 7:
              _context61.next = 10;
              break;
            case 9:
              BossMessage(false, "Add failed:" + backData.result);
            case 10:
            case "end":
              return _context61.stop();
          }
        }, _callee61);
      })();
    },
    update_multi_dns: function update_multi_dns(_ref123, _ref124) {
      var payload = _ref123.payload;
      var call = _ref124.call,
        put = _ref124.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee62() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee62$(_context62) {
          while (1) switch (_context62.prev = _context62.next) {
            case 0:
              _context62.next = 2;
              return call(_update_multi_dns, payload.update);
            case 2:
              backData = _context62.sent;
              if (!backData.success) {
                _context62.next = 9;
                break;
              }
              BossMessage(true, "Successfully modified");
              _context62.next = 7;
              return put({
                type: "get_multi_dns",
                payload: {
                  device_id: payload.update.device_id
                }
              });
            case 7:
              _context62.next = 10;
              break;
            case 9:
              BossMessage(false, "Modification failed" + backData.result);
            case 10:
            case "end":
              return _context62.stop();
          }
        }, _callee62);
      })();
    },
    delete_multi_dns: function delete_multi_dns(_ref125, _ref126) {
      var payload = _ref125.payload;
      var call = _ref126.call,
        put = _ref126.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee63() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee63$(_context63) {
          while (1) switch (_context63.prev = _context63.next) {
            case 0:
              _context63.next = 2;
              return call(_delete_multi_dns, payload);
            case 2:
              backData = _context63.sent;
              if (!backData.success) {
                _context63.next = 9;
                break;
              }
              BossMessage(true, "Successfully deleted");
              _context63.next = 7;
              return put({
                type: "get_multi_dns",
                payload: {
                  device_id: payload.device_id
                }
              });
            case 7:
              _context63.next = 10;
              break;
            case 9:
              BossMessage(false, "Delete failed" + backData.result);
            case 10:
            case "end":
              return _context63.stop();
          }
        }, _callee63);
      })();
    },
    get_device_list: function get_device_list(_ref127, _ref128) {
      var payload = _ref127.payload,
        callback = _ref127.callback;
      var call = _ref128.call,
        put = _ref128.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee64() {
        var backData, data;
        return _regeneratorRuntime().wrap(function _callee64$(_context64) {
          while (1) switch (_context64.prev = _context64.next) {
            case 0:
              _context64.next = 2;
              return call(_get_device_list, payload);
            case 2:
              backData = _context64.sent;
              data = backData.result && Array.isArray(backData.result) ? backData.result : [];
              _context64.next = 6;
              return put({
                type: "update",
                payload: {
                  deviceData: data
                }
              });
            case 6:
              if (callback && typeof callback === 'function') {
                callback(data);
              }
            case 7:
            case "end":
              return _context64.stop();
          }
        }, _callee64);
      })();
    },
    get_domain_group: function get_domain_group(_ref129, _ref130) {
      var payload = _ref129.payload;
      var call = _ref130.call,
        put = _ref130.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee65() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee65$(_context65) {
          while (1) switch (_context65.prev = _context65.next) {
            case 0:
              _context65.next = 2;
              return call(_get_domain_group, payload);
            case 2:
              backData = _context65.sent;
              _context65.next = 5;
              return put({
                type: "update",
                payload: {
                  domainGroupList: backData.result
                }
              });
            case 5:
            case "end":
              return _context65.stop();
          }
        }, _callee65);
      })();
    },
    get_all_alarms_count: function get_all_alarms_count(_ref131, _ref132) {
      var payload = _ref131.payload;
      var call = _ref132.call,
        put = _ref132.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee66() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee66$(_context66) {
          while (1) switch (_context66.prev = _context66.next) {
            case 0:
              _context66.next = 2;
              return call(_get_all_alarms_count, payload);
            case 2:
              backData = _context66.sent;
              _context66.next = 5;
              return put({
                type: "update",
                payload: {
                  allalarmscount: backData.count
                }
              });
            case 5:
            case "end":
              return _context66.stop();
          }
        }, _callee66);
      })();
    },
    get_alert_history_count: function get_alert_history_count(_ref133, _ref134) {
      var payload = _ref133.payload;
      var call = _ref134.call,
        put = _ref134.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee67() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee67$(_context67) {
          while (1) switch (_context67.prev = _context67.next) {
            case 0:
              _context67.next = 2;
              return call(_get_alert_history_count, payload);
            case 2:
              backData = _context67.sent;
              _context67.next = 5;
              return put({
                type: "update",
                payload: {
                  allalarmscount: backData.data && backData.data.total ? backData.data.total : 0
                }
              });
            case 5:
            case "end":
              return _context67.stop();
          }
        }, _callee67);
      })();
    },
    query_alert_history: function query_alert_history(_ref135, _ref136) {
      var payload = _ref135.payload;
      var call = _ref136.call,
        put = _ref136.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee68() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee68$(_context68) {
          while (1) switch (_context68.prev = _context68.next) {
            case 0:
              _context68.next = 2;
              return call(_query_alert_history, payload);
            case 2:
              backData = _context68.sent;
              _context68.next = 5;
              return put({
                type: "update",
                payload: {
                  alarmList: backData.data && backData.data.result && Array.isArray(backData.data.result) ? backData.data.result : [],
                  alarmListTotal: backData.data.total
                }
              });
            case 5:
            case "end":
              return _context68.stop();
          }
        }, _callee68);
      })();
    },
    get_app_account_stat: function get_app_account_stat(_ref137, _ref138) {
      var payload = _ref137.payload;
      var call = _ref138.call,
        put = _ref138.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee69() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee69$(_context69) {
          while (1) switch (_context69.prev = _context69.next) {
            case 0:
              _context69.next = 2;
              return call(_get_app_account_stat, payload);
            case 2:
              backData = _context69.sent;
              _context69.next = 5;
              return put({
                type: "update",
                payload: {
                  appAccount: backData
                }
              });
            case 5:
            case "end":
              return _context69.stop();
          }
        }, _callee69);
      })();
    },
    get_wan_info: function get_wan_info(_ref139, _ref140) {
      var payload = _ref139.payload;
      var call = _ref140.call,
        put = _ref140.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee70() {
        var backData, i;
        return _regeneratorRuntime().wrap(function _callee70$(_context70) {
          while (1) switch (_context70.prev = _context70.next) {
            case 0:
              _context70.next = 2;
              return call(_get_wan_info, payload);
            case 2:
              backData = _context70.sent;
              _context70.next = 5;
              return put({
                type: "update",
                payload: {
                  wanInfo: backData.result
                }
              });
            case 5:
              for (i = 0; i < backData.result.length; i++) {
                if (backData.result[i].name === '4g') {
                  // backData.result[i].port_type ='4g';
                  // const backData2=yield call(get_4g_strength_latest,{
                  //     sn:payload.sn,
                  //     iface:payload.interface
                  // });
                  // backData.result[i].g4Strength = backData2.data
                  backData.result[i].g4Strength = 0;
                } else {
                  backData.result[i].port_type = 'wan';
                  backData.result[i].net_type = 'wanAccType';
                }
              }
              _context70.next = 8;
              return put({
                type: "update",
                payload: {
                  physical: backData.result,
                  rows: 1
                }
              });
            case 8:
            case "end":
              return _context70.stop();
          }
        }, _callee70);
      })();
    },
    update_device: function update_device(_ref141, _ref142) {
      var payload = _ref141.payload;
      var call = _ref142.call,
        put = _ref142.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee71() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee71$(_context71) {
          while (1) switch (_context71.prev = _context71.next) {
            case 0:
              _context71.next = 2;
              return call(_update_device, payload.update);
            case 2:
              backData = _context71.sent;
              if (!backData.success) {
                _context71.next = 11;
                break;
              }
              BossMessage(true, "Operation successful");
              _context71.next = 7;
              return call(all_company_update, {
                company_id: payload.init.company_id
              });
            case 7:
              _context71.next = 9;
              return put({
                type: "get_device_list",
                payload: {
                  id: payload.update.id
                }
              });
            case 9:
              _context71.next = 12;
              break;
            case 11:
              BossMessage(false, "operation failed");
            case 12:
            case "end":
              return _context71.stop();
          }
        }, _callee71);
      })();
    },
    get_link_list: function get_link_list(_ref143, _ref144) {
      var payload = _ref143.payload;
      var call = _ref144.call,
        put = _ref144.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee72() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee72$(_context72) {
          while (1) switch (_context72.prev = _context72.next) {
            case 0:
              _context72.next = 2;
              return call(_get_link_list, payload);
            case 2:
              backData = _context72.sent;
              _context72.next = 5;
              return put({
                type: 'update',
                payload: {
                  dataSource: backData && backData.result && Array.isArray(backData.result) ? backData.result : [],
                  linkTotal: backData.total
                }
              });
            case 5:
            case "end":
              return _context72.stop();
          }
        }, _callee72);
      })();
    },
    get_link: function get_link(_ref145, _ref146) {
      var payload = _ref145.payload;
      var call = _ref146.call,
        put = _ref146.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee73() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee73$(_context73) {
          while (1) switch (_context73.prev = _context73.next) {
            case 0:
              _context73.next = 2;
              return call(_get_link, payload);
            case 2:
              backData = _context73.sent;
              _context73.t0 = backData.link_info.grade;
              _context73.next = _context73.t0 === "CLOUD_SPLINE" ? 6 : _context73.t0 === "CLOUD_VPN" ? 8 : _context73.t0 === "SUPER_CLOUD_SPLINE" ? 10 : 12;
              break;
            case 6:
              backData.link_info.grade = "Cloud dedicated line";
              return _context73.abrupt("break", 13);
            case 8:
              backData.link_info.grade = "Cloud VPN";
              return _context73.abrupt("break", 13);
            case 10:
              backData.link_info.grade = "Super cloud dedicated line";
              return _context73.abrupt("break", 13);
            case 12:
              return _context73.abrupt("break", 13);
            case 13:
              _context73.next = 15;
              return put({
                type: "update",
                payload: {
                  link_info: backData.link_info,
                  agency_list: backData.agency_list
                }
              });
            case 15:
            case "end":
              return _context73.stop();
          }
        }, _callee73);
      })();
    },
    get_l3_tunnel: function get_l3_tunnel(_ref147, _ref148) {
      var payload = _ref147.payload;
      var call = _ref148.call,
        put = _ref148.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee74() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee74$(_context74) {
          while (1) switch (_context74.prev = _context74.next) {
            case 0:
              _context74.next = 2;
              return call(_get_l3_tunnel, payload);
            case 2:
              backData = _context74.sent;
              _context74.next = 5;
              return put({
                type: "update",
                payload: {
                  l3TunnelData: backData.result
                }
              });
            case 5:
            case "end":
              return _context74.stop();
          }
        }, _callee74);
      })();
    },
    get_step_userinfo: function get_step_userinfo(_ref149, _ref150) {
      var payload = _ref149.payload;
      var call = _ref150.call,
        put = _ref150.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee75() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee75$(_context75) {
          while (1) switch (_context75.prev = _context75.next) {
            case 0:
              _context75.next = 2;
              return call(_get_step_userinfo, payload);
            case 2:
              backData = _context75.sent;
              _context75.next = 5;
              return put({
                type: "update",
                payload: {
                  stepUserInfo: backData.data && Array.isArray(backData.data) ? backData.data : []
                }
              });
            case 5:
            case "end":
              return _context75.stop();
          }
        }, _callee75);
      })();
    },
    get_centre_agency_detail: function get_centre_agency_detail(_ref151, _ref152) {
      var payload = _ref151.payload;
      var call = _ref152.call,
        put = _ref152.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee76() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee76$(_context76) {
          while (1) switch (_context76.prev = _context76.next) {
            case 0:
              _context76.next = 2;
              return call(_get_centre_agency_detail, payload);
            case 2:
              backData = _context76.sent;
              _context76.next = 5;
              return put({
                type: "update",
                payload: {
                  agencyDetailData: backData.result
                }
              });
            case 5:
            case "end":
              return _context76.stop();
          }
        }, _callee76);
      })();
    },
    get_device_model: function get_device_model(_ref153, _ref154) {
      var payload = _ref153.payload;
      var call = _ref154.call,
        put = _ref154.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee77() {
        var backData, wifiBandList;
        return _regeneratorRuntime().wrap(function _callee77$(_context77) {
          while (1) switch (_context77.prev = _context77.next) {
            case 0:
              _context77.next = 2;
              return call(_get_device_model, payload);
            case 2:
              backData = _context77.sent;
              wifiBandList = [];
              if (backData.result[0] && backData.result[0].wifi_bands) {
                if (backData.result[0].wifi_bands.indexOf('2.4G') > -1) {
                  wifiBandList.push('2.4G');
                }
                if (backData.result[0].wifi_bands.indexOf('5G') > -1) {
                  wifiBandList.push('5G');
                }
              }
              backData.result[0].wifi_bands;
              _context77.next = 8;
              return put({
                type: "update",
                payload: {
                  wifiBandList: wifiBandList
                }
              });
            case 8:
            case "end":
              return _context77.stop();
          }
        }, _callee77);
      })();
    },
    get_port_series: function get_port_series(_ref155, _ref156) {
      var payload = _ref155.payload;
      var call = _ref156.call,
        put = _ref156.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee78() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee78$(_context78) {
          while (1) switch (_context78.prev = _context78.next) {
            case 0:
              _context78.next = 2;
              return call(_get_port_series, payload);
            case 2:
              backData = _context78.sent;
              _context78.next = 5;
              return put({
                type: "update",
                payload: {
                  portSeriesData: backData.data && backData.data.desc ? backData.data.desc : {}
                }
              });
            case 5:
            case "end":
              return _context78.stop();
          }
        }, _callee78);
      })();
    },
    create_vyos_lan: function create_vyos_lan(_ref157, _ref158) {
      var payload = _ref157.payload,
        callback = _ref157.callback;
      var call = _ref158.call,
        put = _ref158.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee79() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee79$(_context79) {
          while (1) switch (_context79.prev = _context79.next) {
            case 0:
              _context79.next = 2;
              return call(_create_vyos_lan, payload.update);
            case 2:
              backData = _context79.sent;
              if (!(backData.retcode === 0)) {
                _context79.next = 14;
                break;
              }
              BossMessage(true, "Successfully added");
              _context79.next = 7;
              return call(all_company_update, {
                company_id: payload.initcompany.company_id
              });
            case 7:
              _context79.next = 9;
              return put({
                type: "get_vyos_lan",
                payload: {
                  cta_id: payload.update.cta_id
                }
              });
            case 9:
              _context79.next = 11;
              return put({
                type: "get_physical_ports_info",
                payload: {
                  cta_id: payload.update.cta_id
                }
              });
            case 11:
              if (callback && typeof callback === 'function') {
                callback();
              }
              _context79.next = 16;
              break;
            case 14:
              BossMessage(false, "Add failed:" + backData.msg);
              if (callback && typeof callback === 'function') {
                callback({
                  noClose: true
                });
              }
            case 16:
            case "end":
              return _context79.stop();
          }
        }, _callee79);
      })();
    },
    update_vyos_lan: function update_vyos_lan(_ref159, _ref160) {
      var payload = _ref159.payload,
        callback = _ref159.callback;
      var call = _ref160.call,
        put = _ref160.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee80() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee80$(_context80) {
          while (1) switch (_context80.prev = _context80.next) {
            case 0:
              _context80.next = 2;
              return call(_update_vyos_lan, payload.update);
            case 2:
              backData = _context80.sent;
              if (!(backData.retcode === 0)) {
                _context80.next = 14;
                break;
              }
              BossMessage(true, "Update successful");
              _context80.next = 7;
              return call(all_company_update, {
                company_id: payload.initcompany.company_id
              });
            case 7:
              _context80.next = 9;
              return put({
                type: "get_vyos_lan",
                payload: {
                  cta_id: payload.update.cta_id
                }
              });
            case 9:
              _context80.next = 11;
              return put({
                type: "get_physical_ports_info",
                payload: {
                  cta_id: payload.update.cta_id
                }
              });
            case 11:
              if (callback && typeof callback === 'function') {
                callback();
              }
              _context80.next = 16;
              break;
            case 14:
              BossMessage(false, "Update failed" + backData.msg);
              if (callback && typeof callback === 'function') {
                callback({
                  noClose: true
                });
              }
            case 16:
            case "end":
              return _context80.stop();
          }
        }, _callee80);
      })();
    },
    bind_vyos_dhcp: function bind_vyos_dhcp(_ref161, _ref162) {
      var payload = _ref161.payload;
      var call = _ref162.call,
        put = _ref162.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee81() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee81$(_context81) {
          while (1) switch (_context81.prev = _context81.next) {
            case 0:
              _context81.next = 2;
              return call(_bind_vyos_dhcp, payload.update);
            case 2:
              backData = _context81.sent;
              if (!(backData.retcode === 0)) {
                _context81.next = 11;
                break;
              }
              BossMessage(true, "Update successful");
              _context81.next = 7;
              return call(all_company_update, {
                company_id: payload.initcompany.company_id
              });
            case 7:
              _context81.next = 9;
              return put({
                type: "get_vyos_lan",
                payload: {
                  cta_id: payload.update.cta_id
                }
              });
            case 9:
              _context81.next = 12;
              break;
            case 11:
              BossMessage(false, "Update failed" + backData.msg);
            case 12:
            case "end":
              return _context81.stop();
          }
        }, _callee81);
      })();
    },
    get_vyos_lan: function get_vyos_lan(_ref163, _ref164) {
      var payload = _ref163.payload;
      var call = _ref164.call,
        put = _ref164.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee82() {
        var backData, backData2, data1, data2, dataLan;
        return _regeneratorRuntime().wrap(function _callee82$(_context82) {
          while (1) switch (_context82.prev = _context82.next) {
            case 0:
              _context82.next = 2;
              return call(_get_vyos_lan, payload);
            case 2:
              backData = _context82.sent;
              backData2 = {};
              data1 = [], data2 = [];
              data1 = backData.data && backData.data.result && Array.isArray(backData.data.result) ? backData.data.result : [];
              if (payload.forVyos) {
                _context82.next = 11;
                break;
              }
              _context82.next = 9;
              return call(_get_vyos_vlan, _objectSpread({}, payload, {
                bind_type: 2
              }));
            case 9:
              backData2 = _context82.sent;
              data2 = backData2.data && backData2.data.result && Array.isArray(backData2.data.result) ? backData2.data.result : [];
            case 11:
              dataLan = data1.concat(data2);
              _context82.next = 14;
              return put({
                type: "update",
                payload: {
                  dataLan: dataLan
                }
              });
            case 14:
            case "end":
              return _context82.stop();
          }
        }, _callee82);
      })();
    },
    delete_vyos_lan: function delete_vyos_lan(_ref165, _ref166) {
      var payload = _ref165.payload;
      var call = _ref166.call,
        put = _ref166.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee83() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee83$(_context83) {
          while (1) switch (_context83.prev = _context83.next) {
            case 0:
              _context83.next = 2;
              return call(_delete_vyos_lan, payload.update);
            case 2:
              backData = _context83.sent;
              if (!(backData.retcode === 0)) {
                _context83.next = 11;
                break;
              }
              BossMessage(true, "Successfully deleted");
              _context83.next = 7;
              return call(all_company_update, {
                company_id: payload.initcompany.company_id
              });
            case 7:
              _context83.next = 9;
              return put({
                type: "get_vyos_lan",
                payload: {
                  cta_id: payload.update.cta_id
                }
              });
            case 9:
              _context83.next = 12;
              break;
            case 11:
              BossMessage(false, "Delete failed" + backData.msg);
            case 12:
            case "end":
              return _context83.stop();
          }
        }, _callee83);
      })();
    },
    create_vyos_vlan: function create_vyos_vlan(_ref167, _ref168) {
      var payload = _ref167.payload,
        callback = _ref167.callback;
      var call = _ref168.call,
        put = _ref168.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee84() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee84$(_context84) {
          while (1) switch (_context84.prev = _context84.next) {
            case 0:
              _context84.next = 2;
              return call(_create_vyos_vlan, payload.update);
            case 2:
              backData = _context84.sent;
              if (!(backData.retcode === 0)) {
                _context84.next = 15;
                break;
              }
              BossMessage(true, "Successfully added");
              if (!(payload.update.bind_type === 1)) {
                _context84.next = 10;
                break;
              }
              _context84.next = 8;
              return put({
                type: "get_vyos_wan",
                payload: {
                  cta_id: payload.update.cta_id
                }
              });
            case 8:
              _context84.next = 12;
              break;
            case 10:
              _context84.next = 12;
              return put({
                type: "get_vyos_lan",
                payload: {
                  cta_id: payload.update.cta_id
                }
              });
            case 12:
              if (callback && typeof callback === 'function') {
                callback();
              }
              _context84.next = 17;
              break;
            case 15:
              BossMessage(false, "Add failed:" + backData.msg);
              if (callback && typeof callback === 'function') {
                callback({
                  noClose: true
                });
              }
            case 17:
            case "end":
              return _context84.stop();
          }
        }, _callee84);
      })();
    },
    update_vyos_vlan: function update_vyos_vlan(_ref169, _ref170) {
      var payload = _ref169.payload,
        callback = _ref169.callback;
      var call = _ref170.call,
        put = _ref170.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee85() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee85$(_context85) {
          while (1) switch (_context85.prev = _context85.next) {
            case 0:
              _context85.next = 2;
              return call(_update_vyos_vlan, payload.update);
            case 2:
              backData = _context85.sent;
              if (!(backData.retcode === 0)) {
                _context85.next = 15;
                break;
              }
              BossMessage(true, "Update successful");
              if (!(payload.update.bind_type === 1)) {
                _context85.next = 10;
                break;
              }
              _context85.next = 8;
              return put({
                type: "get_vyos_wan",
                payload: {
                  cta_id: payload.update.cta_id
                }
              });
            case 8:
              _context85.next = 12;
              break;
            case 10:
              _context85.next = 12;
              return put({
                type: "get_vyos_lan",
                payload: {
                  cta_id: payload.update.cta_id
                }
              });
            case 12:
              if (callback && typeof callback === 'function') {
                callback();
              }
              _context85.next = 17;
              break;
            case 15:
              BossMessage(false, "Update failed" + backData.msg);
              if (callback && typeof callback === 'function') {
                callback({
                  noClose: true
                });
              }
            case 17:
            case "end":
              return _context85.stop();
          }
        }, _callee85);
      })();
    },
    delete_vyos_vlan: function delete_vyos_vlan(_ref171, _ref172) {
      var payload = _ref171.payload;
      var call = _ref172.call,
        put = _ref172.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee86() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee86$(_context86) {
          while (1) switch (_context86.prev = _context86.next) {
            case 0:
              _context86.next = 2;
              return call(_delete_vyos_vlan, payload.update);
            case 2:
              backData = _context86.sent;
              if (!(backData.retcode === 0)) {
                _context86.next = 9;
                break;
              }
              BossMessage(true, "Successfully deleted");
              _context86.next = 7;
              return put({
                type: "get_vyos_lan",
                payload: {
                  cta_id: payload.update.cta_id
                }
              });
            case 7:
              _context86.next = 10;
              break;
            case 9:
              BossMessage(false, "Delete failed" + backData.msg);
            case 10:
            case "end":
              return _context86.stop();
          }
        }, _callee86);
      })();
    },
    bind_vlan_firewall: function bind_vlan_firewall(_ref173, _ref174) {
      var payload = _ref173.payload;
      var call = _ref174.call,
        put = _ref174.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee87() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee87$(_context87) {
          while (1) switch (_context87.prev = _context87.next) {
            case 0:
              _context87.next = 2;
              return call(_bind_vlan_firewall, payload.update);
            case 2:
              backData = _context87.sent;
              if (!(backData.retcode === 0)) {
                _context87.next = 9;
                break;
              }
              BossMessage(true, "Update successful");
              _context87.next = 7;
              return call(all_company_update, {
                company_id: payload.initcompany.company_id
              });
            case 7:
              _context87.next = 10;
              break;
            case 9:
              BossMessage(false, "Update failed" + backData.msg);
            case 10:
            case "end":
              return _context87.stop();
          }
        }, _callee87);
      })();
    },
    bind_wan_firewall: function bind_wan_firewall(_ref175, _ref176) {
      var payload = _ref175.payload;
      var call = _ref176.call,
        put = _ref176.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee88() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee88$(_context88) {
          while (1) switch (_context88.prev = _context88.next) {
            case 0:
              _context88.next = 2;
              return call(_bind_wan_firewall, payload.update);
            case 2:
              backData = _context88.sent;
              if (!(backData.retcode === 0)) {
                _context88.next = 9;
                break;
              }
              BossMessage(true, "Update successful");
              _context88.next = 7;
              return call(all_company_update, {
                company_id: payload.initcompany.company_id
              });
            case 7:
              _context88.next = 10;
              break;
            case 9:
              BossMessage(false, "Update failed" + backData.msg);
            case 10:
            case "end":
              return _context88.stop();
          }
        }, _callee88);
      })();
    },
    bind_redirect_ip: function bind_redirect_ip(_ref177, _ref178) {
      var payload = _ref177.payload;
      var call = _ref178.call,
        put = _ref178.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee89() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee89$(_context89) {
          while (1) switch (_context89.prev = _context89.next) {
            case 0:
              _context89.next = 2;
              return call(_bind_redirect_ip, payload.update);
            case 2:
              backData = _context89.sent;
              if (!(backData.retcode === 0)) {
                _context89.next = 9;
                break;
              }
              BossMessage(true, "Update successful"); // yield call(all_company_update,{company_id:payload.initcompany.company_id})
              _context89.next = 7;
              return put({
                type: "get_cta_wan",
                payload: {
                  cta_id: payload.update.cta_id
                }
              });
            case 7:
              _context89.next = 10;
              break;
            case 9:
              BossMessage(false, "Update failed" + backData.msg);
            case 10:
            case "end":
              return _context89.stop();
          }
        }, _callee89);
      })();
    },
    bind_wan_snat: function bind_wan_snat(_ref179, _ref180) {
      var payload = _ref179.payload;
      var call = _ref180.call,
        put = _ref180.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee90() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee90$(_context90) {
          while (1) switch (_context90.prev = _context90.next) {
            case 0:
              _context90.next = 2;
              return call(_bind_wan_snat, payload.update);
            case 2:
              backData = _context90.sent;
              if (backData.retcode === 0) {
                BossMessage(true, "Update successful"); // yield call(all_company_update,{company_id:payload.initcompany.company_id})
                // yield put({
                //     type: "get_cta_wan",
                //     payload: {
                //         cta_id:payload.update.cta_id
                //     }
                // });
              } else {
                BossMessage(false, "Update failed" + backData.msg);
              }
            case 4:
            case "end":
              return _context90.stop();
          }
        }, _callee90);
      })();
    },
    bind_wan_dns_interception: function bind_wan_dns_interception(_ref181, _ref182) {
      var payload = _ref181.payload;
      var call = _ref182.call,
        put = _ref182.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee91() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee91$(_context91) {
          while (1) switch (_context91.prev = _context91.next) {
            case 0:
              _context91.next = 2;
              return call(_bind_wan_dns_interception, payload.update);
            case 2:
              backData = _context91.sent;
              if (backData.retcode === 0) {
                BossMessage(true, "Update successful"); // yield call(all_company_update,{company_id:payload.initcompany.company_id})
              } else {
                BossMessage(false, "Update failed" + backData.msg);
              }
            case 4:
            case "end":
              return _context91.stop();
          }
        }, _callee91);
      })();
    },
    get_policy_number_range: function get_policy_number_range(_ref183, _ref184) {
      var payload = _ref183.payload,
        callback = _ref183.callback;
      var call = _ref184.call,
        put = _ref184.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee92() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee92$(_context92) {
          while (1) switch (_context92.prev = _context92.next) {
            case 0:
              _context92.next = 2;
              return call(_get_policy_number_range, payload);
            case 2:
              backData = _context92.sent;
              if (callback && typeof callback === 'function') {
                callback(backData.data);
              }
            case 4:
            case "end":
              return _context92.stop();
          }
        }, _callee92);
      })();
    },
    bind_tunnel_flow: function bind_tunnel_flow(_ref185, _ref186) {
      var payload = _ref185.payload;
      var call = _ref186.call,
        put = _ref186.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee93() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee93$(_context93) {
          while (1) switch (_context93.prev = _context93.next) {
            case 0:
              _context93.next = 2;
              return call(_bind_tunnel_flow, payload.update);
            case 2:
              backData = _context93.sent;
              if (!(backData.retcode === 0)) {
                _context93.next = 16;
                break;
              }
              BossMessage(true, "Update successful");
              _context93.next = 7;
              return call(all_company_update, {
                company_id: payload.initcompany.company_id
              });
            case 7:
              if (!(payload.update.bind_type == 'lan')) {
                _context93.next = 12;
                break;
              }
              _context93.next = 10;
              return put({
                type: "get_vyos_lan",
                payload: {
                  cta_id: payload.update.cta_id
                }
              });
            case 10:
              _context93.next = 14;
              break;
            case 12:
              _context93.next = 14;
              return put({
                type: "get_vyos_wan",
                payload: {
                  cta_id: payload.update.cta_id
                }
              });
            case 14:
              _context93.next = 17;
              break;
            case 16:
              BossMessage(false, "Update failed" + backData.msg);
            case 17:
            case "end":
              return _context93.stop();
          }
        }, _callee93);
      })();
    },
    delete_uci_command: function delete_uci_command(_ref187, _ref188) {
      var payload = _ref187.payload;
      var call = _ref188.call,
        put = _ref188.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee94() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee94$(_context94) {
          while (1) switch (_context94.prev = _context94.next) {
            case 0:
              _context94.next = 2;
              return call(_delete_uci_command, payload.update);
            case 2:
              backData = _context94.sent;
              if (!(backData.retcode === 0)) {
                _context94.next = 9;
                break;
              }
              BossMessage(true, "Operation successful");
              _context94.next = 7;
              return put({
                type: "get_uci_command",
                payload: payload.init
              });
            case 7:
              _context94.next = 10;
              break;
            case 9:
              BossMessage(false, "operation failed" + backData.msg);
            case 10:
            case "end":
              return _context94.stop();
          }
        }, _callee94);
      })();
    },
    get_vyos_wan: function get_vyos_wan(_ref189, _ref190) {
      var payload = _ref189.payload;
      var call = _ref190.call,
        put = _ref190.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee95() {
        var backData, backData2, data1, data2, dataWan;
        return _regeneratorRuntime().wrap(function _callee95$(_context95) {
          while (1) switch (_context95.prev = _context95.next) {
            case 0:
              _context95.next = 2;
              return call(_get_vyos_wan, payload);
            case 2:
              backData = _context95.sent;
              backData2 = {};
              data1 = [], data2 = [];
              data1 = backData.data && backData.data.result && Array.isArray(backData.data.result) ? backData.data.result : [];
              if (payload.forVyos) {
                _context95.next = 11;
                break;
              }
              _context95.next = 9;
              return call(_get_vyos_vlan, _objectSpread({}, payload, {
                bind_type: 1
              }));
            case 9:
              backData2 = _context95.sent;
              data2 = backData2.data && backData2.data.result && Array.isArray(backData2.data.result) ? backData2.data.result : [];
            case 11:
              dataWan = data1.concat(data2);
              _context95.next = 14;
              return put({
                type: "update",
                payload: {
                  dataWan: dataWan
                }
              });
            case 14:
            case "end":
              return _context95.stop();
          }
        }, _callee95);
      })();
    },
    create_vyos_wan: function create_vyos_wan(_ref191, _ref192) {
      var payload = _ref191.payload,
        callback = _ref191.callback;
      var call = _ref192.call,
        put = _ref192.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee96() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee96$(_context96) {
          while (1) switch (_context96.prev = _context96.next) {
            case 0:
              _context96.next = 2;
              return call(_create_vyos_wan, payload.update);
            case 2:
              backData = _context96.sent;
              if (!(backData.retcode === 0)) {
                _context96.next = 11;
                break;
              }
              BossMessage(true, "Successfully added");
              _context96.next = 7;
              return call(all_company_update, {
                company_id: payload.initcompany.company_id
              });
            case 7:
              _context96.next = 9;
              return put({
                type: "get_vyos_wan",
                payload: {
                  cta_id: payload.update.cta_id
                }
              });
            case 9:
              _context96.next = 13;
              break;
            case 11:
              BossMessage(false, "Add failed:" + backData.msg);
              if (callback && typeof callback === 'function') {
                callback({
                  noClose: true
                });
              }
            case 13:
            case "end":
              return _context96.stop();
          }
        }, _callee96);
      })();
    },
    update_vyos_wan: function update_vyos_wan(_ref193, _ref194) {
      var payload = _ref193.payload,
        callback = _ref193.callback;
      var call = _ref194.call,
        put = _ref194.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee97() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee97$(_context97) {
          while (1) switch (_context97.prev = _context97.next) {
            case 0:
              _context97.next = 2;
              return call(_update_vyos_wan, _objectSpread({}, payload.update, {
                gateway: payload.update.gateway ? payload.update.gateway : ''
              }));
            case 2:
              backData = _context97.sent;
              if (!(backData.retcode === 0)) {
                _context97.next = 11;
                break;
              }
              BossMessage(true, "Update successful");
              _context97.next = 7;
              return call(all_company_update, {
                company_id: payload.initcompany.company_id
              });
            case 7:
              _context97.next = 9;
              return put({
                type: "get_vyos_wan",
                payload: {
                  cta_id: payload.update.cta_id
                }
              });
            case 9:
              _context97.next = 13;
              break;
            case 11:
              BossMessage(false, "Update failed" + backData.msg);
              if (callback && typeof callback === 'function') {
                callback({
                  noClose: true
                });
              }
            case 13:
            case "end":
              return _context97.stop();
          }
        }, _callee97);
      })();
    },
    delete_vyos_wan: function delete_vyos_wan(_ref195, _ref196) {
      var payload = _ref195.payload;
      var call = _ref196.call,
        put = _ref196.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee98() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee98$(_context98) {
          while (1) switch (_context98.prev = _context98.next) {
            case 0:
              _context98.next = 2;
              return call(_delete_vyos_wan, payload.update);
            case 2:
              backData = _context98.sent;
              if (!(backData.retcode === 0)) {
                _context98.next = 11;
                break;
              }
              BossMessage(true, "Successfully deleted");
              _context98.next = 7;
              return call(all_company_update, {
                company_id: payload.initcompany.company_id
              });
            case 7:
              _context98.next = 9;
              return put({
                type: "get_vyos_wan",
                payload: {
                  cta_id: payload.update.cta_id
                }
              });
            case 9:
              _context98.next = 12;
              break;
            case 11:
              BossMessage(false, "Delete failed" + backData.msg);
            case 12:
            case "end":
              return _context98.stop();
          }
        }, _callee98);
      })();
    },
    get_interface_alias: function get_interface_alias(_ref197, _ref198) {
      var payload = _ref197.payload,
        callback = _ref197.callback;
      var call = _ref198.call,
        put = _ref198.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee99() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee99$(_context99) {
          while (1) switch (_context99.prev = _context99.next) {
            case 0:
              _context99.next = 2;
              return call(_get_interface_alias, payload);
            case 2:
              backData = _context99.sent;
              if (backData.retcode === 0) {
                if (callback && typeof callback === 'function') {
                  callback(backData.data);
                }
              } else {
                BossMessage(false, backData.msg);
                if (callback && typeof callback === 'function') {
                  callback('');
                }
              }
            // yield put({
            //     type:"update",
            //     payload:{
            //         interface_alias: 'lan3',
            //     }
            // })
            case 4:
            case "end":
              return _context99.stop();
          }
        }, _callee99);
      })();
    },
    delete_vyos_static_route: function delete_vyos_static_route(_ref199, _ref200) {
      var payload = _ref199.payload;
      var call = _ref200.call,
        put = _ref200.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee100() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee100$(_context100) {
          while (1) switch (_context100.prev = _context100.next) {
            case 0:
              _context100.next = 2;
              return call(_delete_vyos_static_route, payload);
            case 2:
              backData = _context100.sent;
              if (!(backData.retcode === 0)) {
                _context100.next = 9;
                break;
              }
              BossMessage(true, "Successfully deleted");
              _context100.next = 7;
              return put({
                type: "get_vyos_static_route",
                payload: {
                  cta_id: payload.cta_id,
                  company_id: payload.company_id
                }
              });
            case 7:
              _context100.next = 10;
              break;
            case 9:
              BossMessage(false, "Delete failed" + backData.msg);
            case 10:
            case "end":
              return _context100.stop();
          }
        }, _callee100);
      })();
    },
    create_vyos_static_route: function create_vyos_static_route(_ref201, _ref202) {
      var payload = _ref201.payload,
        callback = _ref201.callback;
      var call = _ref202.call,
        put = _ref202.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee101() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee101$(_context101) {
          while (1) switch (_context101.prev = _context101.next) {
            case 0:
              if (payload.update && String(payload.update.cta_lan_id) == 'undefined') {
                payload.update.cta_lan_id = 0;
              }
              _context101.next = 3;
              return call(_create_vyos_static_route, payload.update);
            case 3:
              backData = _context101.sent;
              if (!(backData.retcode === 0)) {
                _context101.next = 10;
                break;
              }
              BossMessage(true, "Successfully added");
              _context101.next = 8;
              return put({
                type: "get_vyos_static_route",
                payload: {
                  cta_id: payload.update.cta_id
                }
              });
            case 8:
              _context101.next = 12;
              break;
            case 10:
              BossMessage(false, "Add failed:" + backData.msg);
              if (callback && typeof callback === 'function') {
                callback({
                  noClose: true
                });
              }
            case 12:
            case "end":
              return _context101.stop();
          }
        }, _callee101);
      })();
    },
    update_vyos_static_route: function update_vyos_static_route(_ref203, _ref204) {
      var payload = _ref203.payload,
        callback = _ref203.callback;
      var call = _ref204.call,
        put = _ref204.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee102() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee102$(_context102) {
          while (1) switch (_context102.prev = _context102.next) {
            case 0:
              if (payload.update && String(payload.update.cta_lan_id) == 'undefined') {
                payload.update.cta_lan_id = 0;
              }
              _context102.next = 3;
              return call(_update_vyos_static_route, payload.update);
            case 3:
              backData = _context102.sent;
              if (!(backData.retcode === 0)) {
                _context102.next = 10;
                break;
              }
              BossMessage(true, "Update successful");
              _context102.next = 8;
              return put({
                type: "get_vyos_static_route",
                payload: {
                  cta_id: payload.update.cta_id
                }
              });
            case 8:
              _context102.next = 12;
              break;
            case 10:
              BossMessage(false, "Update failed" + backData.msg);
              if (callback && typeof callback === 'function') {
                callback({
                  noClose: true
                });
              }
            case 12:
            case "end":
              return _context102.stop();
          }
        }, _callee102);
      })();
    },
    get_vyos_static_route: function get_vyos_static_route(_ref205, _ref206) {
      var payload = _ref205.payload;
      var call = _ref206.call,
        put = _ref206.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee103() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee103$(_context103) {
          while (1) switch (_context103.prev = _context103.next) {
            case 0:
              _context103.next = 2;
              return call(_get_vyos_static_route, payload);
            case 2:
              backData = _context103.sent;
              _context103.next = 5;
              return put({
                type: "update",
                payload: {
                  routeList: backData.data && backData.data.result && Array.isArray(backData.data.result) ? backData.data.result : []
                }
              });
            case 5:
            case "end":
              return _context103.stop();
          }
        }, _callee103);
      })();
    },
    get_vyos_vlan: function get_vyos_vlan(_ref207, _ref208) {
      var payload = _ref207.payload;
      var call = _ref208.call,
        put = _ref208.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee104() {
        var backData, vlanData;
        return _regeneratorRuntime().wrap(function _callee104$(_context104) {
          while (1) switch (_context104.prev = _context104.next) {
            case 0:
              _context104.next = 2;
              return call(_get_vyos_vlan, payload);
            case 2:
              backData = _context104.sent;
              vlanData = backData.data && backData.data.result && Array.isArray(backData.data.result) ? backData.data.result : [];
              _context104.next = 6;
              return put({
                type: "update",
                payload: {
                  vlanData: vlanData
                }
              });
            case 6:
            case "end":
              return _context104.stop();
          }
        }, _callee104);
      })();
    },
    get_bgp: function get_bgp(_ref209, _ref210) {
      var payload = _ref209.payload,
        callback = _ref209.callback;
      var call = _ref210.call,
        put = _ref210.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee105() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee105$(_context105) {
          while (1) switch (_context105.prev = _context105.next) {
            case 0:
              _context105.next = 2;
              return call(_get_bgp, payload);
            case 2:
              backData = _context105.sent;
              _context105.next = 5;
              return put({
                type: "update",
                payload: {
                  bgpData: backData.data
                }
              });
            case 5:
              if (backData.data && backData.data.id) {
                _context105.next = 8;
                break;
              }
              _context105.next = 8;
              return put({
                type: "update",
                payload: {
                  bgpNeighborList1: [],
                  bgpNeighborTotal1: 0,
                  bgpNeighborList2: [],
                  bgpNeighborTotal2: 0,
                  bgpNeighborList3: [],
                  bgpNeighborTotal3: 0
                }
              });
            case 8:
              if (callback && typeof callback === 'function') {
                callback(backData.data);
              }
            case 9:
            case "end":
              return _context105.stop();
          }
        }, _callee105);
      })();
    },
    query_bgp_neighbor_list1: function query_bgp_neighbor_list1(_ref211, _ref212) {
      var payload = _ref211.payload;
      var call = _ref212.call,
        put = _ref212.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee106() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee106$(_context106) {
          while (1) switch (_context106.prev = _context106.next) {
            case 0:
              _context106.next = 2;
              return call(query_bgp_neighbor_list, payload);
            case 2:
              backData = _context106.sent;
              _context106.next = 5;
              return put({
                type: "update",
                payload: {
                  bgpNeighborList1: backData.data && backData.data.result && Array.isArray(backData.data.result) ? backData.data.result : [],
                  initBgpPayload1: payload,
                  bgpNeighborTotal1: backData.data && backData.data.total ? backData.data.total : 0
                }
              });
            case 5:
            case "end":
              return _context106.stop();
          }
        }, _callee106);
      })();
    },
    query_bgp_neighbor_list2: function query_bgp_neighbor_list2(_ref213, _ref214) {
      var payload = _ref213.payload;
      var call = _ref214.call,
        put = _ref214.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee107() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee107$(_context107) {
          while (1) switch (_context107.prev = _context107.next) {
            case 0:
              _context107.next = 2;
              return call(query_bgp_neighbor_list, payload);
            case 2:
              backData = _context107.sent;
              _context107.next = 5;
              return put({
                type: "update",
                payload: {
                  bgpNeighborList2: backData.data && backData.data.result && Array.isArray(backData.data.result) ? backData.data.result : [],
                  initBgpPayload2: payload,
                  bgpNeighborTotal2: backData.data && backData.data.total ? backData.data.total : 0
                }
              });
            case 5:
            case "end":
              return _context107.stop();
          }
        }, _callee107);
      })();
    },
    query_bgp_neighbor_list3: function query_bgp_neighbor_list3(_ref215, _ref216) {
      var payload = _ref215.payload;
      var call = _ref216.call,
        put = _ref216.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee108() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee108$(_context108) {
          while (1) switch (_context108.prev = _context108.next) {
            case 0:
              _context108.next = 2;
              return call(query_bgp_neighbor_list, payload);
            case 2:
              backData = _context108.sent;
              _context108.next = 5;
              return put({
                type: "update",
                payload: {
                  bgpNeighborList3: backData.data && backData.data.result && Array.isArray(backData.data.result) ? backData.data.result : [],
                  initBgpPayload3: payload,
                  bgpNeighborTotal3: backData.data && backData.data.total ? backData.data.total : 0
                }
              });
            case 5:
            case "end":
              return _context108.stop();
          }
        }, _callee108);
      })();
    },
    create_bgp_neighbor: function create_bgp_neighbor(_ref217, _ref218) {
      var payload = _ref217.payload,
        callback = _ref217.callback;
      var select = _ref218.select,
        call = _ref218.call,
        put = _ref218.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee109() {
        var backData, initBgpPayload1, initBgpPayload2, initBgpPayload3;
        return _regeneratorRuntime().wrap(function _callee109$(_context109) {
          while (1) switch (_context109.prev = _context109.next) {
            case 0:
              _context109.next = 2;
              return call(_create_bgp_neighbor, payload.update);
            case 2:
              backData = _context109.sent;
              if (!(backData.retcode === 0)) {
                _context109.next = 35;
                break;
              }
              BossMessage(true, "Successfully added");
              if (!(payload.update.action === 1)) {
                _context109.next = 13;
                break;
              }
              _context109.next = 8;
              return select(function (state) {
                return state.ci2802Info.initBgpPayload1;
              });
            case 8:
              initBgpPayload1 = _context109.sent;
              _context109.next = 11;
              return put({
                type: "query_bgp_neighbor_list1",
                payload: initBgpPayload1
              });
            case 11:
              _context109.next = 32;
              break;
            case 13:
              if (!(payload.update.action === 2)) {
                _context109.next = 21;
                break;
              }
              _context109.next = 16;
              return select(function (state) {
                return state.ci2802Info.initBgpPayload2;
              });
            case 16:
              initBgpPayload2 = _context109.sent;
              _context109.next = 19;
              return put({
                type: "query_bgp_neighbor_list2",
                payload: initBgpPayload2
              });
            case 19:
              _context109.next = 32;
              break;
            case 21:
              if (!(payload.update.action === 3)) {
                _context109.next = 29;
                break;
              }
              _context109.next = 24;
              return select(function (state) {
                return state.ci2802Info.initBgpPayload3;
              });
            case 24:
              initBgpPayload3 = _context109.sent;
              _context109.next = 27;
              return put({
                type: "query_bgp_neighbor_list3",
                payload: initBgpPayload3
              });
            case 27:
              _context109.next = 32;
              break;
            case 29:
              if (!(payload.update.action === 4)) {
                _context109.next = 32;
                break;
              }
              _context109.next = 32;
              return put({
                type: "get_bgp",
                payload: {
                  device_sn: payload.update.device_sn,
                  company_id: payload.update.company_id
                }
              });
            case 32:
              if (callback && typeof callback === 'function') {
                callback();
              }
              _context109.next = 37;
              break;
            case 35:
              BossMessage(false, "Add failed:" + backData.msg);
              if (callback && typeof callback === 'function') {
                callback({
                  noClose: true
                });
              }
            case 37:
            case "end":
              return _context109.stop();
          }
        }, _callee109);
      })();
    },
    update_bgp_neighbor: function update_bgp_neighbor(_ref219, _ref220) {
      var payload = _ref219.payload,
        callback = _ref219.callback;
      var select = _ref220.select,
        call = _ref220.call,
        put = _ref220.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee110() {
        var backData, initBgpPayload1, initBgpPayload2, initBgpPayload3;
        return _regeneratorRuntime().wrap(function _callee110$(_context110) {
          while (1) switch (_context110.prev = _context110.next) {
            case 0:
              _context110.next = 2;
              return call(_update_bgp_neighbor, payload.update);
            case 2:
              backData = _context110.sent;
              if (!(backData.retcode === 0)) {
                _context110.next = 35;
                break;
              }
              BossMessage(true, "Successfully modified");
              if (!(payload.update.action === 1)) {
                _context110.next = 13;
                break;
              }
              _context110.next = 8;
              return select(function (state) {
                return state.ci2802Info.initBgpPayload1;
              });
            case 8:
              initBgpPayload1 = _context110.sent;
              _context110.next = 11;
              return put({
                type: "query_bgp_neighbor_list1",
                payload: initBgpPayload1
              });
            case 11:
              _context110.next = 32;
              break;
            case 13:
              if (!(payload.update.action === 2)) {
                _context110.next = 21;
                break;
              }
              _context110.next = 16;
              return select(function (state) {
                return state.ci2802Info.initBgpPayload2;
              });
            case 16:
              initBgpPayload2 = _context110.sent;
              _context110.next = 19;
              return put({
                type: "query_bgp_neighbor_list2",
                payload: initBgpPayload2
              });
            case 19:
              _context110.next = 32;
              break;
            case 21:
              if (!(payload.update.action === 3)) {
                _context110.next = 29;
                break;
              }
              _context110.next = 24;
              return select(function (state) {
                return state.ci2802Info.initBgpPayload3;
              });
            case 24:
              initBgpPayload3 = _context110.sent;
              _context110.next = 27;
              return put({
                type: "query_bgp_neighbor_list3",
                payload: initBgpPayload3
              });
            case 27:
              _context110.next = 32;
              break;
            case 29:
              if (!(payload.update.action === 4)) {
                _context110.next = 32;
                break;
              }
              _context110.next = 32;
              return put({
                type: "get_bgp",
                payload: {
                  device_sn: payload.update.device_sn,
                  company_id: payload.update.company_id
                }
              });
            case 32:
              if (callback && typeof callback === 'function') {
                callback();
              }
              _context110.next = 37;
              break;
            case 35:
              BossMessage(false, "Modification failed:" + backData.msg);
              if (callback && typeof callback === 'function') {
                callback({
                  noClose: true
                });
              }
            case 37:
            case "end":
              return _context110.stop();
          }
        }, _callee110);
      })();
    },
    delete_bgp_neighbor: function delete_bgp_neighbor(_ref221, _ref222) {
      var payload = _ref221.payload;
      var select = _ref222.select,
        call = _ref222.call,
        put = _ref222.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee111() {
        var backData, initBgpPayload1, initBgpPayload2, initBgpPayload3;
        return _regeneratorRuntime().wrap(function _callee111$(_context111) {
          while (1) switch (_context111.prev = _context111.next) {
            case 0:
              _context111.next = 2;
              return call(_delete_bgp_neighbor, payload.update);
            case 2:
              backData = _context111.sent;
              if (!(backData.retcode === 0)) {
                _context111.next = 29;
                break;
              }
              BossMessage(true, "Successfully deleted");
              if (!(payload.update.action === 1)) {
                _context111.next = 13;
                break;
              }
              _context111.next = 8;
              return select(function (state) {
                return state.ci2802Info.initBgpPayload1;
              });
            case 8:
              initBgpPayload1 = _context111.sent;
              _context111.next = 11;
              return put({
                type: "query_bgp_neighbor_list1",
                payload: initBgpPayload1
              });
            case 11:
              _context111.next = 27;
              break;
            case 13:
              if (!(payload.update.action === 2)) {
                _context111.next = 21;
                break;
              }
              _context111.next = 16;
              return select(function (state) {
                return state.ci2802Info.initBgpPayload2;
              });
            case 16:
              initBgpPayload2 = _context111.sent;
              _context111.next = 19;
              return put({
                type: "query_bgp_neighbor_list2",
                payload: initBgpPayload2
              });
            case 19:
              _context111.next = 27;
              break;
            case 21:
              if (!(payload.update.action === 3)) {
                _context111.next = 27;
                break;
              }
              _context111.next = 24;
              return select(function (state) {
                return state.ci2802Info.initBgpPayload3;
              });
            case 24:
              initBgpPayload3 = _context111.sent;
              _context111.next = 27;
              return put({
                type: "query_bgp_neighbor_list3",
                payload: initBgpPayload3
              });
            case 27:
              _context111.next = 30;
              break;
            case 29:
              BossMessage(false, "Delete failed:" + backData.msg);
            case 30:
            case "end":
              return _context111.stop();
          }
        }, _callee111);
      })();
    },
    create_bgp: function create_bgp(_ref223, _ref224) {
      var payload = _ref223.payload,
        callback = _ref223.callback;
      var call = _ref224.call,
        put = _ref224.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee112() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee112$(_context112) {
          while (1) switch (_context112.prev = _context112.next) {
            case 0:
              _context112.next = 2;
              return call(_create_bgp, payload.update);
            case 2:
              backData = _context112.sent;
              if (!(backData.retcode === 0)) {
                _context112.next = 10;
                break;
              }
              BossMessage(true, "Successfully added");
              _context112.next = 7;
              return put({
                type: "get_bgp",
                payload: payload.init
              });
            case 7:
              if (callback && typeof callback === 'function') {
                callback();
              }
              _context112.next = 12;
              break;
            case 10:
              BossMessage(false, "Add failed:" + backData.msg);
              if (callback && typeof callback === 'function') {
                callback({
                  noClose: true
                });
              }
            case 12:
            case "end":
              return _context112.stop();
          }
        }, _callee112);
      })();
    },
    update_ospf: function update_ospf(_ref225, _ref226) {
      var payload = _ref225.payload,
        callback = _ref225.callback;
      var call = _ref226.call,
        put = _ref226.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee113() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee113$(_context113) {
          while (1) switch (_context113.prev = _context113.next) {
            case 0:
              _context113.next = 2;
              return call(_update_ospf, payload.update);
            case 2:
              backData = _context113.sent;
              if (!(backData.retcode === 0)) {
                _context113.next = 10;
                break;
              }
              BossMessage(true, "Successfully modified");
              _context113.next = 7;
              return put({
                type: "query_ospf_area_list",
                payload: payload.init
              });
            case 7:
              if (callback && typeof callback === 'function') {
                callback();
              }
              _context113.next = 11;
              break;
            case 10:
              BossMessage(false, "Modification failed:" + backData.msg);
            case 11:
            case "end":
              return _context113.stop();
          }
        }, _callee113);
      })();
    },
    query_ospf_area_list: function query_ospf_area_list(_ref227, _ref228) {
      var payload = _ref227.payload,
        callback = _ref227.callback;
      var call = _ref228.call,
        put = _ref228.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee114() {
        var backData, routerId;
        return _regeneratorRuntime().wrap(function _callee114$(_context114) {
          while (1) switch (_context114.prev = _context114.next) {
            case 0:
              _context114.next = 2;
              return call(_query_ospf_area_list, payload);
            case 2:
              backData = _context114.sent;
              if (!(payload.config_type === 1)) {
                _context114.next = 10;
                break;
              }
              routerId = backData.data && backData.data.result && backData.data.result[0] && backData.data.result[0].router_id ? backData.data.result[0].router_id : "";
              _context114.next = 7;
              return put({
                type: "update",
                payload: {
                  ospfRouterId: routerId
                }
              });
            case 7:
              if (callback && typeof callback === 'function') {
                callback(routerId);
              }
              _context114.next = 12;
              break;
            case 10:
              _context114.next = 12;
              return put({
                type: "update",
                payload: {
                  ospfAreaList: backData.data && backData.data.result && Array.isArray(backData.data.result) ? backData.data.result : []
                }
              });
            case 12:
            case "end":
              return _context114.stop();
          }
        }, _callee114);
      })();
    },
    create_ospf_area: function create_ospf_area(_ref229, _ref230) {
      var payload = _ref229.payload,
        callback = _ref229.callback;
      var call = _ref230.call,
        put = _ref230.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee115() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee115$(_context115) {
          while (1) switch (_context115.prev = _context115.next) {
            case 0:
              _context115.next = 2;
              return call(_create_ospf_area, payload.update);
            case 2:
              backData = _context115.sent;
              if (backData.retcode === 0) {
                BossMessage(true, "Successfully added");
                if (callback && typeof callback === 'function') {
                  callback();
                }
              } else {
                BossMessage(false, "Add failed:" + backData.msg);
                if (callback && typeof callback === 'function') {
                  callback({
                    noClose: true
                  });
                }
              }
            case 4:
            case "end":
              return _context115.stop();
          }
        }, _callee115);
      })();
    },
    update_ospf_area: function update_ospf_area(_ref231, _ref232) {
      var payload = _ref231.payload,
        callback = _ref231.callback;
      var call = _ref232.call,
        put = _ref232.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee116() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee116$(_context116) {
          while (1) switch (_context116.prev = _context116.next) {
            case 0:
              _context116.next = 2;
              return call(_update_ospf_area, payload.update);
            case 2:
              backData = _context116.sent;
              if (backData.retcode === 0) {
                BossMessage(true, "Successfully modified");
                if (callback && typeof callback === 'function') {
                  callback();
                }
              } else {
                BossMessage(false, "Modification failed:" + backData.msg);
                if (callback && typeof callback === 'function') {
                  callback({
                    noClose: true
                  });
                }
              }
            case 4:
            case "end":
              return _context116.stop();
          }
        }, _callee116);
      })();
    },
    delete_ospf_area: function delete_ospf_area(_ref233, _ref234) {
      var payload = _ref233.payload;
      var call = _ref234.call,
        put = _ref234.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee117() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee117$(_context117) {
          while (1) switch (_context117.prev = _context117.next) {
            case 0:
              _context117.next = 2;
              return call(_delete_ospf_area, payload.update);
            case 2:
              backData = _context117.sent;
              if (!(backData.retcode === 0)) {
                _context117.next = 11;
                break;
              }
              BossMessage(true, "Successfully deleted");
              _context117.next = 7;
              return put({
                type: "query_ospf_area_list",
                payload: payload.init
              });
            case 7:
              _context117.next = 9;
              return put({
                type: "query_ospf_area_network",
                payload: payload.init2
              });
            case 9:
              _context117.next = 12;
              break;
            case 11:
              BossMessage(false, "Delete failed:" + backData.msg);
            case 12:
            case "end":
              return _context117.stop();
          }
        }, _callee117);
      })();
    },
    query_ospf_area_network: function query_ospf_area_network(_ref235, _ref236) {
      var payload = _ref235.payload,
        callback = _ref235.callback;
      var call = _ref236.call,
        put = _ref236.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee118() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee118$(_context118) {
          while (1) switch (_context118.prev = _context118.next) {
            case 0:
              _context118.next = 2;
              return call(_query_ospf_area_network, payload);
            case 2:
              backData = _context118.sent;
              _context118.next = 5;
              return put({
                type: "update",
                payload: {
                  ospfNetworkList: backData.data && backData.data.result && Array.isArray(backData.data.result) ? backData.data.result : []
                }
              });
            case 5:
            case "end":
              return _context118.stop();
          }
        }, _callee118);
      })();
    },
    create_ospf_area_network: function create_ospf_area_network(_ref237, _ref238) {
      var payload = _ref237.payload,
        callback = _ref237.callback;
      var call = _ref238.call,
        put = _ref238.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee119() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee119$(_context119) {
          while (1) switch (_context119.prev = _context119.next) {
            case 0:
              _context119.next = 2;
              return call(_create_ospf_area_network, payload.update);
            case 2:
              backData = _context119.sent;
              if (backData.retcode === 0) {
                BossMessage(true, "Successfully added");
                if (callback && typeof callback === 'function') {
                  callback();
                }
              } else {
                BossMessage(false, "Add failed:" + backData.msg);
                if (callback && typeof callback === 'function') {
                  callback({
                    noClose: true
                  });
                }
              }
            case 4:
            case "end":
              return _context119.stop();
          }
        }, _callee119);
      })();
    },
    update_ospf_area_network: function update_ospf_area_network(_ref239, _ref240) {
      var payload = _ref239.payload,
        callback = _ref239.callback;
      var call = _ref240.call,
        put = _ref240.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee120() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee120$(_context120) {
          while (1) switch (_context120.prev = _context120.next) {
            case 0:
              _context120.next = 2;
              return call(_update_ospf_area_network, payload.update);
            case 2:
              backData = _context120.sent;
              if (backData.retcode === 0) {
                BossMessage(true, "Successfully edited");
                if (callback && typeof callback === 'function') {
                  callback();
                }
              } else {
                BossMessage(false, "Editing failed:" + backData.msg);
                if (callback && typeof callback === 'function') {
                  callback({
                    noClose: true
                  });
                }
              }
            case 4:
            case "end":
              return _context120.stop();
          }
        }, _callee120);
      })();
    },
    delete_ospf_area_network: function delete_ospf_area_network(_ref241, _ref242) {
      var payload = _ref241.payload;
      var call = _ref242.call,
        put = _ref242.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee121() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee121$(_context121) {
          while (1) switch (_context121.prev = _context121.next) {
            case 0:
              _context121.next = 2;
              return call(_delete_ospf_area_network, payload.update);
            case 2:
              backData = _context121.sent;
              if (!(backData.retcode === 0)) {
                _context121.next = 9;
                break;
              }
              BossMessage(true, "Successfully deleted");
              _context121.next = 7;
              return put({
                type: "query_ospf_area_network",
                payload: payload.init
              });
            case 7:
              _context121.next = 10;
              break;
            case 9:
              BossMessage(false, "Delete failed:" + backData.msg);
            case 10:
            case "end":
              return _context121.stop();
          }
        }, _callee121);
      })();
    },
    query_pbr_list: function query_pbr_list(_ref243, _ref244) {
      var payload = _ref243.payload,
        callback = _ref243.callback;
      var call = _ref244.call,
        put = _ref244.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee122() {
        var backData, data, pbrList, i;
        return _regeneratorRuntime().wrap(function _callee122$(_context122) {
          while (1) switch (_context122.prev = _context122.next) {
            case 0:
              _context122.next = 2;
              return call(_query_pbr_list, payload);
            case 2:
              backData = _context122.sent;
              data = backData.data.result;
              pbrList = [];
              for (i in data) {
                pbrList.push({
                  key: i,
                  name: i.split('---')[0] ? i.split('---')[0] : '',
                  network_interface: i.split('---')[1] ? i.split('---')[1] : '',
                  detailData: data[i].sort(function (a, b) {
                    return a.distance - b.distance;
                  })
                });
              }
              _context122.next = 8;
              return put({
                type: "update",
                payload: {
                  pbrList: pbrList,
                  initPbrPayload: payload
                }
              });
            case 8:
            case "end":
              return _context122.stop();
          }
        }, _callee122);
      })();
    },
    create_pbr: function create_pbr(_ref245, _ref246) {
      var payload = _ref245.payload,
        callback = _ref245.callback;
      var select = _ref246.select,
        call = _ref246.call,
        put = _ref246.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee123() {
        var backData, initPbrPayload;
        return _regeneratorRuntime().wrap(function _callee123$(_context123) {
          while (1) switch (_context123.prev = _context123.next) {
            case 0:
              _context123.next = 2;
              return call(_create_pbr, payload.update);
            case 2:
              backData = _context123.sent;
              if (!(backData.retcode === 0)) {
                _context123.next = 13;
                break;
              }
              BossMessage(true, "Successfully added");
              _context123.next = 7;
              return select(function (state) {
                return state.ci2802Info.initPbrPayload;
              });
            case 7:
              initPbrPayload = _context123.sent;
              _context123.next = 10;
              return put({
                type: "query_pbr_list",
                payload: initPbrPayload
              });
            case 10:
              if (callback && typeof callback === 'function') {
                callback();
              }
              _context123.next = 15;
              break;
            case 13:
              BossMessage(false, "Add failed:" + backData.msg);
              if (callback && typeof callback === 'function') {
                callback({
                  noClose: true
                });
              }
            case 15:
            case "end":
              return _context123.stop();
          }
        }, _callee123);
      })();
    },
    update_pbr: function update_pbr(_ref247, _ref248) {
      var payload = _ref247.payload,
        callback = _ref247.callback;
      var select = _ref248.select,
        call = _ref248.call,
        put = _ref248.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee124() {
        var backData, initPbrPayload;
        return _regeneratorRuntime().wrap(function _callee124$(_context124) {
          while (1) switch (_context124.prev = _context124.next) {
            case 0:
              _context124.next = 2;
              return call(_update_pbr, payload.update);
            case 2:
              backData = _context124.sent;
              if (!(backData.retcode === 0)) {
                _context124.next = 13;
                break;
              }
              BossMessage(true, "Successfully modified");
              _context124.next = 7;
              return select(function (state) {
                return state.ci2802Info.initPbrPayload;
              });
            case 7:
              initPbrPayload = _context124.sent;
              _context124.next = 10;
              return put({
                type: "query_pbr_list",
                payload: initPbrPayload
              });
            case 10:
              if (callback && typeof callback === 'function') {
                callback();
              }
              _context124.next = 15;
              break;
            case 13:
              BossMessage(false, "Modification failed:" + backData.msg);
              if (callback && typeof callback === 'function') {
                callback({
                  noClose: true
                });
              }
            case 15:
            case "end":
              return _context124.stop();
          }
        }, _callee124);
      })();
    },
    update_pbr_detail: function update_pbr_detail(_ref249, _ref250) {
      var payload = _ref249.payload,
        callback = _ref249.callback;
      var select = _ref250.select,
        call = _ref250.call,
        put = _ref250.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee125() {
        var backData, initPbrPayload;
        return _regeneratorRuntime().wrap(function _callee125$(_context125) {
          while (1) switch (_context125.prev = _context125.next) {
            case 0:
              _context125.next = 2;
              return call(_update_pbr_detail, payload.update);
            case 2:
              backData = _context125.sent;
              if (!(backData.retcode === 0)) {
                _context125.next = 13;
                break;
              }
              BossMessage(true, "Successfully modified");
              _context125.next = 7;
              return select(function (state) {
                return state.ci2802Info.initPbrPayload;
              });
            case 7:
              initPbrPayload = _context125.sent;
              _context125.next = 10;
              return put({
                type: "query_pbr_list",
                payload: initPbrPayload
              });
            case 10:
              if (callback && typeof callback === 'function') {
                callback();
              }
              _context125.next = 15;
              break;
            case 13:
              BossMessage(false, "Modification failed:" + backData.msg);
              if (callback && typeof callback === 'function') {
                callback({
                  noClose: true
                });
              }
            case 15:
            case "end":
              return _context125.stop();
          }
        }, _callee125);
      })();
    },
    delete_pbr: function delete_pbr(_ref251, _ref252) {
      var payload = _ref251.payload;
      var select = _ref252.select,
        call = _ref252.call,
        put = _ref252.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee126() {
        var backData, initPbrPayload;
        return _regeneratorRuntime().wrap(function _callee126$(_context126) {
          while (1) switch (_context126.prev = _context126.next) {
            case 0:
              _context126.next = 2;
              return call(_delete_pbr, payload.update);
            case 2:
              backData = _context126.sent;
              if (!(backData.retcode === 0)) {
                _context126.next = 12;
                break;
              }
              BossMessage(true, "Successfully deleted");
              _context126.next = 7;
              return select(function (state) {
                return state.ci2802Info.initPbrPayload;
              });
            case 7:
              initPbrPayload = _context126.sent;
              _context126.next = 10;
              return put({
                type: "query_pbr_list",
                payload: initPbrPayload
              });
            case 10:
              _context126.next = 13;
              break;
            case 12:
              BossMessage(false, "Delete failed:" + backData.msg);
            case 13:
            case "end":
              return _context126.stop();
          }
        }, _callee126);
      })();
    },
    get_network_interface: function get_network_interface(_ref253, _ref254) {
      var payload = _ref253.payload,
        callback = _ref253.callback;
      var call = _ref254.call,
        put = _ref254.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee127() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee127$(_context127) {
          while (1) switch (_context127.prev = _context127.next) {
            case 0:
              _context127.next = 2;
              return call(_get_network_interface, payload);
            case 2:
              backData = _context127.sent;
              _context127.next = 5;
              return put({
                type: "update",
                payload: {
                  interfaceList: backData.data && backData.data.result && Array.isArray(backData.data.result) ? backData.data.result : []
                }
              });
            case 5:
            case "end":
              return _context127.stop();
          }
        }, _callee127);
      })();
    },
    get_link_list_by_sn: function get_link_list_by_sn(_ref255, _ref256) {
      var payload = _ref255.payload;
      var call = _ref256.call,
        put = _ref256.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee128() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee128$(_context128) {
          while (1) switch (_context128.prev = _context128.next) {
            case 0:
              _context128.next = 2;
              return call(_get_link_list_by_sn, payload);
            case 2:
              backData = _context128.sent;
              _context128.next = 5;
              return put({
                type: 'update',
                payload: {
                  linkList: backData && backData.data && backData.data.result && Array.isArray(backData.data.result) ? backData.data.result : []
                }
              });
            case 5:
            case "end":
              return _context128.stop();
          }
        }, _callee128);
      })();
    },
    query_acl_config_list: function query_acl_config_list(_ref257, _ref258) {
      var payload = _ref257.payload,
        callback = _ref257.callback;
      var call = _ref258.call,
        put = _ref258.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee129() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee129$(_context129) {
          while (1) switch (_context129.prev = _context129.next) {
            case 0:
              _context129.next = 2;
              return call(_query_acl_config_list, payload);
            case 2:
              backData = _context129.sent;
              _context129.next = 5;
              return put({
                type: "update",
                payload: {
                  aclList: backData.data && backData.data.result && Array.isArray(backData.data.result) ? backData.data.result : [],
                  aclTotal: backData.data && backData.data.total ? backData.data.total : 0,
                  initAclPayload: payload
                }
              });
            case 5:
            case "end":
              return _context129.stop();
          }
        }, _callee129);
      })();
    },
    create_acl_config: function create_acl_config(_ref259, _ref260) {
      var payload = _ref259.payload,
        callback = _ref259.callback;
      var select = _ref260.select,
        call = _ref260.call,
        put = _ref260.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee130() {
        var backData, initAclPayload;
        return _regeneratorRuntime().wrap(function _callee130$(_context130) {
          while (1) switch (_context130.prev = _context130.next) {
            case 0:
              _context130.next = 2;
              return call(_create_acl_config, payload.update);
            case 2:
              backData = _context130.sent;
              if (!(backData.retcode === 0)) {
                _context130.next = 13;
                break;
              }
              BossMessage(true, "Successfully added");
              _context130.next = 7;
              return select(function (state) {
                return state.ci2802Info.initAclPayload;
              });
            case 7:
              initAclPayload = _context130.sent;
              _context130.next = 10;
              return put({
                type: "query_acl_config_list",
                payload: initAclPayload
              });
            case 10:
              if (callback && typeof callback === 'function') {
                callback();
              }
              _context130.next = 15;
              break;
            case 13:
              BossMessage(false, "Add failed:" + backData.msg);
              if (callback && typeof callback === 'function') {
                callback({
                  noClose: true
                });
              }
            case 15:
            case "end":
              return _context130.stop();
          }
        }, _callee130);
      })();
    },
    update_acl_config: function update_acl_config(_ref261, _ref262) {
      var payload = _ref261.payload,
        callback = _ref261.callback;
      var select = _ref262.select,
        call = _ref262.call,
        put = _ref262.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee131() {
        var backData, initAclPayload;
        return _regeneratorRuntime().wrap(function _callee131$(_context131) {
          while (1) switch (_context131.prev = _context131.next) {
            case 0:
              _context131.next = 2;
              return call(_update_acl_config, payload.update);
            case 2:
              backData = _context131.sent;
              if (!(backData.retcode === 0)) {
                _context131.next = 13;
                break;
              }
              BossMessage(true, "Successfully modified");
              _context131.next = 7;
              return select(function (state) {
                return state.ci2802Info.initAclPayload;
              });
            case 7:
              initAclPayload = _context131.sent;
              _context131.next = 10;
              return put({
                type: "query_acl_config_list",
                payload: initAclPayload
              });
            case 10:
              if (callback && typeof callback === 'function') {
                callback();
              }
              _context131.next = 15;
              break;
            case 13:
              BossMessage(false, "Modification failed:" + backData.msg);
              if (callback && typeof callback === 'function') {
                callback({
                  noClose: true
                });
              }
            case 15:
            case "end":
              return _context131.stop();
          }
        }, _callee131);
      })();
    },
    active_acl_config: function active_acl_config(_ref263, _ref264) {
      var payload = _ref263.payload;
      var select = _ref264.select,
        call = _ref264.call,
        put = _ref264.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee132() {
        var backData, initAclPayload;
        return _regeneratorRuntime().wrap(function _callee132$(_context132) {
          while (1) switch (_context132.prev = _context132.next) {
            case 0:
              _context132.next = 2;
              return call(_active_acl_config, payload.update);
            case 2:
              backData = _context132.sent;
              if (!(backData.retcode === 0)) {
                _context132.next = 12;
                break;
              }
              BossMessage(true, "Operation successful");
              _context132.next = 7;
              return select(function (state) {
                return state.ci2802Info.initAclPayload;
              });
            case 7:
              initAclPayload = _context132.sent;
              _context132.next = 10;
              return put({
                type: "query_acl_config_list",
                payload: initAclPayload
              });
            case 10:
              _context132.next = 13;
              break;
            case 12:
              BossMessage(false, "Operation failed:" + backData.msg);
            case 13:
            case "end":
              return _context132.stop();
          }
        }, _callee132);
      })();
    },
    delete_acl_config: function delete_acl_config(_ref265, _ref266) {
      var payload = _ref265.payload;
      var select = _ref266.select,
        call = _ref266.call,
        put = _ref266.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee133() {
        var backData, initAclPayload;
        return _regeneratorRuntime().wrap(function _callee133$(_context133) {
          while (1) switch (_context133.prev = _context133.next) {
            case 0:
              _context133.next = 2;
              return call(_delete_acl_config, payload.update);
            case 2:
              backData = _context133.sent;
              if (!(backData.retcode === 0)) {
                _context133.next = 12;
                break;
              }
              BossMessage(true, "Successfully deleted");
              _context133.next = 7;
              return select(function (state) {
                return state.ci2802Info.initAclPayload;
              });
            case 7:
              initAclPayload = _context133.sent;
              _context133.next = 10;
              return put({
                type: "query_acl_config_list",
                payload: initAclPayload
              });
            case 10:
              _context133.next = 13;
              break;
            case 12:
              BossMessage(false, "Delete failed:" + backData.msg);
            case 13:
            case "end":
              return _context133.stop();
          }
        }, _callee133);
      })();
    },
    get_ip_groups: function get_ip_groups(_ref267, _ref268) {
      var payload = _ref267.payload,
        callback = _ref267.callback;
      var call = _ref268.call,
        put = _ref268.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee134() {
        var backData, data, _backData;
        return _regeneratorRuntime().wrap(function _callee134$(_context134) {
          while (1) switch (_context134.prev = _context134.next) {
            case 0:
              if (!(payload.ipType && payload.ipType === 4)) {
                _context134.next = 14;
                break;
              }
              _context134.next = 3;
              return call(_query_device_ip_group, payload);
            case 3:
              backData = _context134.sent;
              data = backData.data && backData.data.result && Array.isArray(backData.data.result) ? backData.data.result : [];
              if (payload.ip_group_id) {
                _context134.next = 10;
                break;
              }
              _context134.next = 8;
              return put({
                type: "update",
                payload: {
                  ipGroupDeviceDataForCompany: data
                }
              });
            case 8:
              _context134.next = 12;
              break;
            case 10:
              _context134.next = 12;
              return put({
                type: "update",
                payload: {
                  ipGroupSourceData: data
                }
              });
            case 12:
              _context134.next = 24;
              break;
            case 14:
              _context134.next = 16;
              return call(_get_ip_groups, payload);
            case 16:
              _backData = _context134.sent;
              if (payload.ip_group_id) {
                _context134.next = 22;
                break;
              }
              _context134.next = 20;
              return put({
                type: "update",
                payload: {
                  ipGroupDataForCompany: _backData.result && Array.isArray(_backData.result) ? _backData.result : []
                }
              });
            case 20:
              _context134.next = 24;
              break;
            case 22:
              _context134.next = 24;
              return put({
                type: "update",
                payload: {
                  ipGroupSourceData: _backData.result && Array.isArray(_backData.result) ? _backData.result : []
                }
              });
            case 24:
            case "end":
              return _context134.stop();
          }
        }, _callee134);
      })();
    },
    query_ospf_redistribute_type: function query_ospf_redistribute_type(_ref269, _ref270) {
      var payload = _ref269.payload,
        callback = _ref269.callback;
      var call = _ref270.call,
        put = _ref270.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee135() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee135$(_context135) {
          while (1) switch (_context135.prev = _context135.next) {
            case 0:
              _context135.next = 2;
              return call(_query_ospf_redistribute_type, payload);
            case 2:
              backData = _context135.sent;
              _context135.next = 5;
              return put({
                type: "update",
                payload: {
                  ospfRedistributeList: backData.data && Array.isArray(backData.data) ? backData.data : []
                }
              });
            case 5:
            case "end":
              return _context135.stop();
          }
        }, _callee135);
      })();
    },
    create_ospf_redistribute_type: function create_ospf_redistribute_type(_ref271, _ref272) {
      var payload = _ref271.payload,
        callback = _ref271.callback;
      var select = _ref272.select,
        call = _ref272.call,
        put = _ref272.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee136() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee136$(_context136) {
          while (1) switch (_context136.prev = _context136.next) {
            case 0:
              _context136.next = 2;
              return call(_create_ospf_redistribute_type, payload.update);
            case 2:
              backData = _context136.sent;
              if (backData.retcode === 0) {
                BossMessage(true, "Successfully added");
                if (callback && typeof callback === 'function') {
                  callback();
                }
              } else {
                BossMessage(false, "Add failed:" + backData.msg);
                if (callback && typeof callback === 'function') {
                  callback({
                    noClose: true
                  });
                }
              }
            case 4:
            case "end":
              return _context136.stop();
          }
        }, _callee136);
      })();
    },
    update_ospf_redistribute_type: function update_ospf_redistribute_type(_ref273, _ref274) {
      var payload = _ref273.payload,
        callback = _ref273.callback;
      var select = _ref274.select,
        call = _ref274.call,
        put = _ref274.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee137() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee137$(_context137) {
          while (1) switch (_context137.prev = _context137.next) {
            case 0:
              _context137.next = 2;
              return call(_update_ospf_redistribute_type, payload.update);
            case 2:
              backData = _context137.sent;
              if (backData.retcode === 0) {
                BossMessage(true, "Successfully modified"); // const initAclPayload = yield select(state => state.ci2802Info.initAclPayload);
                if (callback && typeof callback === 'function') {
                  callback();
                }
              } else {
                BossMessage(false, "Modification failed:" + backData.msg);
                if (callback && typeof callback === 'function') {
                  callback({
                    noClose: true
                  });
                }
              }
            case 4:
            case "end":
              return _context137.stop();
          }
        }, _callee137);
      })();
    },
    delete_ospf_redistribute_type: function delete_ospf_redistribute_type(_ref275, _ref276) {
      var payload = _ref275.payload;
      var select = _ref276.select,
        call = _ref276.call,
        put = _ref276.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee138() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee138$(_context138) {
          while (1) switch (_context138.prev = _context138.next) {
            case 0:
              _context138.next = 2;
              return call(_delete_ospf_redistribute_type, payload.update);
            case 2:
              backData = _context138.sent;
              if (!(backData.retcode === 0)) {
                _context138.next = 9;
                break;
              }
              BossMessage(true, "Successfully deleted");
              _context138.next = 7;
              return put({
                type: "query_ospf_redistribute_type",
                payload: payload.init
              });
            case 7:
              _context138.next = 10;
              break;
            case 9:
              BossMessage(false, "Delete failed:" + backData.msg);
            case 10:
            case "end":
              return _context138.stop();
          }
        }, _callee138);
      })();
    },
    query_device_ip_group: function query_device_ip_group(_ref277, _ref278) {
      var payload = _ref277.payload,
        callback = _ref277.callback;
      var call = _ref278.call,
        put = _ref278.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee139() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee139$(_context139) {
          while (1) switch (_context139.prev = _context139.next) {
            case 0:
              _context139.next = 2;
              return call(_query_device_ip_group, payload);
            case 2:
              backData = _context139.sent;
              if (!(payload.mode === 'normal')) {
                _context139.next = 8;
                break;
              }
              _context139.next = 6;
              return put({
                type: "update",
                payload: {
                  deviceIpList: backData.data && backData.data.result && Array.isArray(backData.data.result) ? backData.data.result : [],
                  initPayloadForDeviceIp: payload
                }
              });
            case 6:
              _context139.next = 10;
              break;
            case 8:
              _context139.next = 10;
              return put({
                type: "update",
                payload: {
                  ipRelationList: backData.data && backData.data.result && Array.isArray(backData.data.result) ? backData.data.result : []
                }
              });
            case 10:
            case "end":
              return _context139.stop();
          }
        }, _callee139);
      })();
    },
    create_device_ip_group: function create_device_ip_group(_ref279, _ref280) {
      var payload = _ref279.payload,
        callback = _ref279.callback;
      var select = _ref280.select,
        call = _ref280.call,
        put = _ref280.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee140() {
        var backData, initPayloadForDeviceIp;
        return _regeneratorRuntime().wrap(function _callee140$(_context140) {
          while (1) switch (_context140.prev = _context140.next) {
            case 0:
              _context140.next = 2;
              return call(_create_device_ip_group, payload.update);
            case 2:
              backData = _context140.sent;
              if (!(backData.retcode === 0)) {
                _context140.next = 13;
                break;
              }
              _context140.next = 6;
              return select(function (state) {
                return state.ci2802Info.initPayloadForDeviceIp;
              });
            case 6:
              initPayloadForDeviceIp = _context140.sent;
              BossMessage(true, "Successfully added");
              if (callback && typeof callback === 'function') {
                callback();
              }
              _context140.next = 11;
              return put({
                type: "query_device_ip_group",
                payload: initPayloadForDeviceIp
              });
            case 11:
              _context140.next = 15;
              break;
            case 13:
              BossMessage(false, "Add failed:" + backData.msg);
              if (callback && typeof callback === 'function') {
                callback({
                  noClose: true
                });
              }
            case 15:
            case "end":
              return _context140.stop();
          }
        }, _callee140);
      })();
    },
    update_device_ip_group: function update_device_ip_group(_ref281, _ref282) {
      var payload = _ref281.payload,
        callback = _ref281.callback;
      var select = _ref282.select,
        call = _ref282.call,
        put = _ref282.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee141() {
        var backData, initPayloadForDeviceIp;
        return _regeneratorRuntime().wrap(function _callee141$(_context141) {
          while (1) switch (_context141.prev = _context141.next) {
            case 0:
              _context141.next = 2;
              return call(_update_device_ip_group, payload.update);
            case 2:
              backData = _context141.sent;
              if (!(backData.retcode === 0)) {
                _context141.next = 13;
                break;
              }
              BossMessage(true, "Successfully modified");
              if (callback && typeof callback === 'function') {
                callback();
              }
              _context141.next = 8;
              return select(function (state) {
                return state.ci2802Info.initPayloadForDeviceIp;
              });
            case 8:
              initPayloadForDeviceIp = _context141.sent;
              _context141.next = 11;
              return put({
                type: "query_device_ip_group",
                payload: initPayloadForDeviceIp
              });
            case 11:
              _context141.next = 15;
              break;
            case 13:
              BossMessage(false, "Modification failed:" + backData.msg);
              if (callback && typeof callback === 'function') {
                callback({
                  noClose: true
                });
              }
            case 15:
            case "end":
              return _context141.stop();
          }
        }, _callee141);
      })();
    },
    delete_device_ip_group: function delete_device_ip_group(_ref283, _ref284) {
      var payload = _ref283.payload,
        callback = _ref283.callback;
      var select = _ref284.select,
        call = _ref284.call,
        put = _ref284.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee142() {
        var backData, initPayloadForDeviceIp;
        return _regeneratorRuntime().wrap(function _callee142$(_context142) {
          while (1) switch (_context142.prev = _context142.next) {
            case 0:
              _context142.next = 2;
              return call(_delete_device_ip_group, payload.update);
            case 2:
              backData = _context142.sent;
              if (!(backData.retcode === 0)) {
                _context142.next = 12;
                break;
              }
              BossMessage(true, "Successfully deleted");
              _context142.next = 7;
              return select(function (state) {
                return state.ci2802Info.initPayloadForDeviceIp;
              });
            case 7:
              initPayloadForDeviceIp = _context142.sent;
              _context142.next = 10;
              return put({
                type: "query_device_ip_group",
                payload: initPayloadForDeviceIp
              });
            case 10:
              _context142.next = 13;
              break;
            case 12:
              if (callback && typeof callback === 'function') {
                callback(backData);
              }
            case 13:
            case "end":
              return _context142.stop();
          }
        }, _callee142);
      })();
    },
    unbind_ip_group: function unbind_ip_group(_ref285, _ref286) {
      var payload = _ref285.payload,
        callback = _ref285.callback;
      var select = _ref286.select,
        call = _ref286.call,
        put = _ref286.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee143() {
        var backData, initPayloadForDeviceIp;
        return _regeneratorRuntime().wrap(function _callee143$(_context143) {
          while (1) switch (_context143.prev = _context143.next) {
            case 0:
              _context143.next = 2;
              return call(_unbind_ip_group, payload.update);
            case 2:
              backData = _context143.sent;
              if (!(backData.retcode === 0)) {
                _context143.next = 12;
                break;
              }
              BossMessage(true, "Operation successful");
              _context143.next = 7;
              return select(function (state) {
                return state.ci2802Info.initPayloadForDeviceIp;
              });
            case 7:
              initPayloadForDeviceIp = _context143.sent;
              _context143.next = 10;
              return put({
                type: "query_device_ip_group",
                payload: _objectSpread({}, initPayloadForDeviceIp, {
                  mode: 'relation'
                })
              });
            case 10:
              _context143.next = 13;
              break;
            case 12:
              if (callback && typeof callback === 'function') {
                callback(backData);
              }
            //BossMessage(false, "@操作失败:" + backData.msg);
            case 13:
            case "end":
              return _context143.stop();
          }
        }, _callee143);
      })();
    },
    clearData: function clearData(_ref287, _ref288) {
      var payload = _ref287.payload;
      var select = _ref288.select,
        call = _ref288.call,
        put = _ref288.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee144() {
        return _regeneratorRuntime().wrap(function _callee144$(_context144) {
          while (1) switch (_context144.prev = _context144.next) {
            case 0:
              _context144.next = 2;
              return put({
                type: "update",
                payload: _objectSpread({}, initState)
              });
            case 2:
            case "end":
              return _context144.stop();
          }
        }, _callee144);
      })();
    }
  },
  reducers: {
    update: function update(state, action) {
      return _objectSpread({}, state, action.payload);
    }
  }
};